import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import _, { each } from "lodash";
import { Oval } from "react-loader-spinner";

import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Column } from 'primereact/column';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Tooltip } from "primereact/tooltip";
import { Sidebar } from 'primereact/sidebar';

import MinusImg from "../../../images/minus.png"
import GreenCheckImg from "../../../images/greentick.png"
import WorkInProgressImg from "../../../images/work-in-progress.png"
import TruckAwaitingImg from "../../../images/truckawaiting.png"
import SmartSearchImg from "../../../images/smart_search.png"
import VPRupeeImg from "../../../images/vp_rupee.jpg"

import { CheckboxField, Table, CalendarField, DropDownField } from "../../../helpers";
import Button from "../../../helpers/Button";
import Menu from "../../../helpers/Menu"

import Loading from "../../../common/Loading";
import CopyToClipboard from "../../../common/CopyToClipboard";
import DispatchDetailsDisplay from "../../../common/DispatchDetailsDisplay";
import PMUserName from "../../../common/PMUserName";
import ButtonGroup from "../../../common/ButtonGroup";

import ConvertToStock from "./Components/convertToStock";
import Search from "./Components/Search";
import CreateDispatchNote from "./Components/CreateDispatchNote";
import CreateInvoice from "./Components/CreateInvoice";
import GRN from "./Components/GRN";

import { getLatestSellerGRNQCPunchesBySellerPODocNos, getsellerGRNQCPunchAcceptedQty, getsellerGRNQCPunchAcceptedQtyForCreateDispatchNote } from "../../../services/api/sellerGRNQCPunch";
import { getMaterialItemsDataByBuyerReqItemIds, getMaterialItemsDataByBuyerReqItemIdsNew } from "../../../services/api/buyerReqItem";
import { insertDispatchNote } from "../../../services/api/dispatchNote";
import { getLogisticsPartners } from "../../../services/api/logistcsPartners";
import { getCompanyBillAddrs } from "../../../services/api/companyBillAddr";
import { getCompanyBranchShipAddrs } from "../../../services/api/companyBranchShipAddr";
import { getBuyerPOItems } from "../../../services/api/buyerPOItem";
import { convertToStockQty, getSellerPOItemsBySellerPOIds, updateSellerPOItem } from "../../../services/api/sellerPOItem";
import { getBuyerInvoicesByBuyerPOIds } from "../../../services/api/buyerInvoice";
import { getPOPunchItemByBuyerPOIds } from "../../../services/api/poPunchItem";
import { getPOScheduleItemsByBuyerPOItemId } from "../../../services/api/poScheduleItem";
import { getPMBranches } from "../../../services/api/pmBranch";
import { getDocCopyByDocNo } from "../../../services/api/docCopy";
import { getStockDocsByDocNos } from "../../../services/api/stockDoc";
import { getWarehouseStatus } from "../../../services/api/warehouseStatusDetails";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchSellerPOs, updateDispatchSPOsData, setInitialLoad, updateSearchParams, updateIsSmartSearch, setIsSearchVisible, setIsSearchPinned } from "../../../services/redux/reducers/dispatch/dispatch";
import {
    fetchStates,
    fetchMaterialBrands,
    fetchMaterialCategories,
    fetchCompanySupplyType,
    fetchHSNMasterData,
    fetchFollowUpStatusData,
    fetchIncoTerms,
    fetchOrderTypesData
} from "../../../services/redux/reducers/commonThunk";

import { calculateDispatchNote, getDateString, getMaterialMasterDetailsTooltip, getCompanyShortName, numberConversion, getFullName, getUOMStr, round, sortArrayOfObjectsInAscendingDateOrder, getMobileNumber, checkPermissions, isMobile ,getReqShortDetails } from "../../../utils";

import "./index.css"

import downloadFile from "../../../utils/DownloadFile";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";
import { stockDocParser } from "../../../parserFunctions";
import RenameBuyerInvoiceItems from "../../../common/RenameBuyerInvoiceItems";
import { DECIMAL_LIMIT } from '../../../constants'
import { getDispatchNoteItemsBySellerPOItemIds } from "../../../services/api/dispatchNoteItem";
import { useSearchPin } from "../../../hooks/useSearchPin";


const Dispatch = () => {
    const dispatch = useDispatch()
    const { isSearchPinned, toggleSearchPin, setSearchPin } = useSearchPin()
    
    const [visibleGRN, setVisibleGRN] = useState(false)
    const [selectedSellerPOForGRN, setSelectedSellerPOForGRN] = useState({})
    const [selectedDispatchSellerPOs, setSelectedDispatchSellerPOs] = useState([])
    const [selectedDispatchSellerPOItems, setSelectedDispatchSellerPOItems] = useState(null)
    const [selectedBuyerPOItems, setSelectedBuyerPOItems] = useState(null)
    const [logisticPartners, setLogisticPartners] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [buyerCompanyBillAddrs, setBuyerCompanyBillAddrs] = useState([])
    const [buyerCompanyPMBillAddrs, setBuyerCompanyPMBillAddrs] = useState([])
    const [buyerCompanyBranchShipAddrs, setBuyerCompanyBranchShipAddrs] = useState([])
    const [selectedBuyerBillAddrId, setSelectedBuyerBillAddrId] = useState(null)
    const [selectedBuyerShipAddrId, setSelectedBuyerShipAddrId] = useState(null)
    const [materialDetails, setMaterialDetails] = useState([])
    const [buyerPOItems, setBuyerPOItems] = useState([])
    const [poPunchItems, setPOPunchItems] = useState([])
    const [poScheduleItems, setPOScheduleItems] = useState([])
    const [selectedPOItemForViewSchedule, setSelectedPOItemForViewSchedule] = useState()
    const [sellerGRNQCPunchAcceptedQtyItems, setSellerGRNQCPunchAcceptedQtyItems] = useState([])
    const [sellerGRNQCPunches, setSellerGRNQCPunches] = useState([])
    const [stockDocs, setStockDocs] = useState([])
    const [isInitialSellerPOsData, setIsInitialSellerPOsData] = useState(false)
    const [visibleRenameBuyerInvoiceItems, setVisibleRenameBuyerInvoiceItems] = useState(false)
    const [buyerReqWiseDispatchNoteItems, setBuyerReqWiseDispatchNoteItems] = useState([])
    const [buyerPOItemWiseDispatchNoteItems, setBuyerPOItemWiseDispatchNoteItems] = useState([])

    const [expandedSellerPORows, setExpandedSellerPORows] = useState(null)
    const [pmBranches, setPMBranches] = useState([])
    const [dataType, setDataType] = useState("dispatchData")
    const [sellerPOIdData, setSellerPOIdData] = useState()

    const [isWarehouseEditable, setIsWarehouseEditable] = useState(false)
    const [isCreateDispatchNoteVisible, setIsCreateDispatchNoteVisible] = useState(false)
    const [isCreateInvoiceModalVisible, setIsCreateInvoiceModalVisible] = useState(false)
    const [isConvertToStockVisible, setIsCovertToStockVisible] = useState(false)
    const [newDispatchNote, setNewDispatchNote] = useState(null)
    const [isConfirmReplaceDialogVisible, setIsConfirmReplaceDialogVisible] = useState(false)
    const [isScheduleHistoryVisible, setIsScheduleHistoryVisible] = useState(false)
    const [isScheduleLoading, setIsScheduleLoading] = useState(false)
    const [isConfirmPreviewDialogVisible, setIsConfirmPreviewDialogVisible] = useState(false)
    const [previewBuyerInvoicesIds, setPreviewBuyerInvoicesIds] = useState([])
    const [selectedWarehouse, setSelectedWarehouse] = useState(null)
    const [warehouseStatus, setWarehouseStatus] = useState({})
    const [userRelatedWarehouses, setUserRelatedWarehouses] = useState([])
    const [currentWarehouse, setCurrentWarehouse] = useState("")
    const [isHoveringSearchZone, setIsHoveringSearchZone] = useState(false)
    const [hasEverHoveredRightEdge, setHasEverHoveredRightEdge] = useState(false)

    const statesList = useSelector((state) => state.common.states)
    const userDetails = useSelector(state => state.userDetails)
    const userId = useSelector((state) => state.userDetails.userId)
    const companyBranches = useSelector(state => state.userDetails.PMCompanyDetails.companyBranches)
    const HSNMasterData = useSelector((state) => state.common.HSNMaster)
    const PMCompanyDetails = useSelector(state => state.userDetails.PMCompanyDetails)
    const incoTerms = useSelector((state) => state.common.incoTerms)

    const isPageLoading = useSelector(state => state.dispatch.loading)
    const isInitialLoad = useSelector(state => state.dispatch.isInitialLoad)
    const searchParams = useSelector(state => state.dispatch.searchParams)
    const paginationParams = useSelector(state => state.dispatch.paginationParams)
    const sellerPOsData = useSelector(state => state.dispatch.sellerPOsData)
    const isSmartSearch = useSelector(state => state.dispatch.isSmartSearch)
    const isSearchVisible = useSelector(state => state.dispatch.isSearchVisible)
    const isSearchActive = useSelector(state => state.dispatch.isSearchActive)
    
    const materialBrands = useSelector((state) => state.common.materialBrands)
    const materialCategories = useSelector((state) => state.common.materialCategories)
    const companySupplyTypes = useSelector((state) => state.common.companySupplyType)
    const followUpStatus = useSelector(state => state.common.followUpStatus)
    const companyWarehouses = useSelector(state => state.userDetails.PMCompanyDetails.companyWarehouses)
    const companyPmBranches = useSelector(state => state.userDetails.PMCompanyDetails.companyPmBranches)
    const userRoleList = useSelector(state => state.userDetails.rolesList)
    const orderTypes = useSelector(state => state.common.orderTypes)

    const actionMenu = useRef(null)

    const isMobileDevice = isMobile()
    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale, currencyShortName } = pmCompanyConfig



    useEffect(() => {
        dispatch(fetchStates())
        dispatch(fetchMaterialBrands())
        dispatch(fetchMaterialCategories())
        dispatch(fetchCompanySupplyType())
        dispatch(fetchHSNMasterData())
        dispatch(fetchFollowUpStatusData())
        dispatch(fetchIncoTerms())
        fetchPMBranches()
        dispatch(fetchOrderTypesData())
    }, [])

    useEffect(() => {
        getIntialLoadData()
    }, [])

    useEffect(() => {
        let sellerPOIdData = {
            sellerPOId: selectedSellerPOForGRN?.sellerPOId
        }
        setSellerPOIdData(sellerPOIdData)
    }, [selectedSellerPOForGRN])

    useEffect(() => {
        if (selectedWarehouse && !isWarehouseEditable){
            getWarehouseStatusDetails()
        }
    }, [selectedWarehouse])

    useEffect(() => {
        if (!isSearchPinned && !isHoveringSearchZone) {
            dispatch(setIsSearchVisible(false))
          }

        const handleMouseMove = (e) => {
            if (isSearchPinned) return

            const panelWidth = window.innerWidth * 0.18
            const buffer = 8
            const screenRightEdge = window.innerWidth
            const activeZoneLeft = screenRightEdge - (panelWidth + buffer)

            if (e.clientX < activeZoneLeft) {
                setIsHoveringSearchZone(false)
                setHasEverHoveredRightEdge(false)
            } else {
                setIsHoveringSearchZone(true)
            }
        }

        if (!isSearchPinned && (isHoveringSearchZone || hasEverHoveredRightEdge)) {
            window.addEventListener('mousemove', handleMouseMove)
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove)
        }
    }, [isSearchPinned, isHoveringSearchZone, hasEverHoveredRightEdge])


    useEffect(() => {
        if (!isInitialSellerPOsData && sellerPOsData.length > 0 && !isPageLoading) {
            if (dataType === "dispatchData") {
                getSellerPOItems()
            }
            getSellerGRNQCPunches()
            setIsInitialSellerPOsData(true)
        }
    }, [sellerPOsData, isInitialSellerPOsData])

    useEffect(() => {
        getLogisticsPartnersData()
    }, [selectedDispatchSellerPOItems])

    useEffect(()=>{
        if(companyWarehouses){
            const relatedPmBranchIds = userRoleList?.map(each => each.branchId)
            const allIndiaLevelBranchId = 0
            let relatedCompanyWarehouse = []

            if(relatedPmBranchIds.includes(allIndiaLevelBranchId)){
                relatedCompanyWarehouse = companyWarehouses
            }else{
                const relatedWarehouseIds = companyPmBranches.filter(each => relatedPmBranchIds.includes(each.branchId))?.map(each => each.warehouseId)
                relatedCompanyWarehouse = companyWarehouses.filter(each => relatedWarehouseIds.includes(each.warehouseId))
            }
            relatedCompanyWarehouse = relatedCompanyWarehouse.filter(eachWarehouse => eachWarehouse.warehouseName !== "DUMMY")
            setUserRelatedWarehouses(relatedCompanyWarehouse)

            const activeRoleBranchId = userRoleList.find(each => each.userRoleId === userDetails.activeRoleId)?.branchId
            if(activeRoleBranchId === 0){
                setSelectedWarehouse(relatedCompanyWarehouse[0].warehouseId) // By default , active role's warehouse as selected warehouse
                setCurrentWarehouse(relatedCompanyWarehouse[0].warehouseName)  // By default , active role's warehouse as current WH

            }else{
                const relatedActiveWarehouseId = companyPmBranches.find(each => each.branchId === activeRoleBranchId)?.warehouseId
                const relatedActiveRoleWarehouse = companyWarehouses.find(each => each.warehouseId === relatedActiveWarehouseId)
                if(relatedActiveRoleWarehouse){
                    setSelectedWarehouse(relatedActiveRoleWarehouse.warehouseId) // By default , active role's warehouse as selected warehouse
                    setCurrentWarehouse(relatedActiveRoleWarehouse.warehouseName)  // By default , active role's warehouse as current WH
                }
            }
        }
    },[companyWarehouses] )

    const fetchPMBranches = async () => {
        const pmBranchesRes = await getPMBranches()

        if (pmBranchesRes.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: pmBranchesRes.data.error, life: 3000 }))
        } else {
            setPMBranches(pmBranchesRes.data)
        }
    }

    const getIntialLoadData = () => {
        if (isInitialLoad) {
            let toDate = new Date()
            toDate.setHours(23, 59, 0, 0)
            toDate = toDate.toISOString()

            let fromDate = new Date()
            fromDate.setDate(fromDate.getDate() - 2)
            fromDate.setHours(0, 0, 0, 0)
            fromDate = fromDate.toISOString()

            const updatedSearchParams = {
                ...searchParams,
                fromDate: fromDate,
                toDate: toDate
            }

            dispatch(updateSearchParams(updatedSearchParams))
            dispatch(setInitialLoad(false))
        }
    }

    const getSellerPOItems = async () => {
        if (sellerPOsData?.length > 0) {
            let sellerPOIds = []
            let sellerPODocNos = []
            let sellerPOFileNos = []
            let buyerPOIds = []

            sellerPOsData.map(eachSellerPO => {
                if (eachSellerPO.sellerPOId) {
                    sellerPOIds.push(eachSellerPO.sellerPOId)
                }

                if (eachSellerPO.docNo) {
                    sellerPODocNos.push(eachSellerPO.docNo)
                }

                if (eachSellerPO.fileNo) {
                    sellerPOFileNos.push(eachSellerPO.fileNo)
                }

                if (eachSellerPO.buyerPOId) {
                    buyerPOIds.push(eachSellerPO.buyerPOId)
                }
            })

            const sellerGRNQCPunchAcceptedQtyResponse = await getsellerGRNQCPunchAcceptedQty({ sellerPODocNos, sellerPOFileNos })
            console.log("sellerGRNQCPunchAcceptedQty-response", sellerGRNQCPunchAcceptedQtyResponse)
            if (sellerGRNQCPunchAcceptedQtyResponse?.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: "Seller GRN QC", detail: sellerGRNQCPunchAcceptedQtyResponse?.data?.error, life: 3000 }))
            } else {
                setSellerGRNQCPunchAcceptedQtyItems(sellerGRNQCPunchAcceptedQtyResponse.data)
            }

            let buyerPOItemsResponse = await getBuyerPOItems({ buyerPOIds, statusIds: [3, 4], paginator: false })
            console.log("buyerPOItems-response", buyerPOItemsResponse)
            if (buyerPOItemsResponse.failure) {
                return dispatch(raiseToast({ severity: 'warn', summary: "Buyer PO Items", detail: buyerPOItemsResponse.data.error, life: 3000 }))
            } else {
                setBuyerPOItems(buyerPOItemsResponse.data.data)
            }

            let poPunchItemsResponse = await getPOPunchItemByBuyerPOIds({ buyerPOIds })
            console.log("poPunchItems-response", poPunchItemsResponse)
            if (poPunchItemsResponse.failure) {
                return dispatch(raiseToast({ severity: 'warn', summary: "PO Punch Items", detail: poPunchItemsResponse.data.error, life: 3000 }))
            } else {
                setPOPunchItems(poPunchItemsResponse.data)
            }


            const sellerPOItemsRes = await getSellerPOItemsBySellerPOIds(sellerPOIds)

            if (sellerPOItemsRes?.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: "Seller PO Items", detail: sellerPOItemsRes?.data?.error, life: 3000 }))
            } else {
                const updatedSellerPOsData = sellerPOsData?.map(eachSellerPO => {
                    const relatedSellerPOItems = sellerPOItemsRes?.data?.filter(eachSellerPOItem => eachSellerPOItem.sellerPOId === eachSellerPO.sellerPOId)
                    return { ...eachSellerPO, sellerPOItems: relatedSellerPOItems }
                })
                const relatedBuyerReqItemIds = sellerPOItemsRes?.data?.map(eachSellerPOItem => eachSellerPOItem?.buyerReqItemId)
                const materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds({ buyerReqItemsIds: relatedBuyerReqItemIds })
                console.log("materialDetails-response", materialDetailsRes)
                if (materialDetailsRes?.failure) {
                    return dispatch(raiseToast({ severity: 'error', summary: "Seller PO Items", detail: materialDetailsRes?.data?.error, life: 3000 }))
                }
                setMaterialDetails(materialDetailsRes?.data)
                dispatch(updateDispatchSPOsData(updatedSellerPOsData))
            }
        }

    }

    const getSellerGRNQCPunches = async () => {
        const sellerPODocNos = sellerPOsData.map(eachSellerPO => eachSellerPO.docNo)
        const sellerPOFileNos = sellerPOsData.map(eachSellerPO => eachSellerPO.fileNo)
        if (sellerPOsData?.length) {
            let sellerGRNQCPunchRes = await getLatestSellerGRNQCPunchesBySellerPODocNos({ sellerPODocNos, sellerPOFileNos })

            if (sellerGRNQCPunchRes.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: "Seller GRN QC Punches", detail: sellerGRNQCPunchRes.data.error, life: 3000 }))
            } else {
                setSellerGRNQCPunches(sellerGRNQCPunchRes.data)
            }
        }
    }

    const getWarehouseStatusDetails = async () => {
        const relatedCompanyWarehouse = companyWarehouses.find(each => each.warehouseId === selectedWarehouse)
        if (relatedCompanyWarehouse) {
            const data = {
                shipAddrId: relatedCompanyWarehouse.shipAddrId
            }
            const response = await getWarehouseStatus(data)
            console.log("warehouseStatus-response", response)
            if (response.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: "Dispatch Details", detail: response.data.error, life: 3000 }))
            }
            setWarehouseStatus(response.data)
            setCurrentWarehouse(relatedCompanyWarehouse.warehouseName)
        }
    }

    const handleWarehouseInputChange = (event) => {
        setSelectedWarehouse(event.target.value)
        const relatedWarehouse = userRelatedWarehouses?.find(each => each.warehouseId === event.target.value)
        setCurrentWarehouse(relatedWarehouse?.warehouseName)
    }

    const getCompanyBillAddrsData = async (billAddrIds, companyIds) => {
        let {isPermitted} = checkPermissions({ ...userDetails, permissions: [151] })

        if ([3].includes(userDetails.activeUserRoleDetails.branchId)){
            isPermitted = true
        }

        if(selectedDispatchSellerPOItems){
            let dispatchSellerPOItemsArr = Object.values(selectedDispatchSellerPOItems).flat()
            if(dispatchSellerPOItemsArr.length > 0){
                const isCatalogAPIReqIdExists = dispatchSellerPOItemsArr.some(eachSellerPOItem => eachSellerPOItem.catalogAPIReqId)
                if(isCatalogAPIReqIdExists){
                    isPermitted = true
                }
            }
        }

        const companyBillAddrResponse = await getCompanyBillAddrs({ companyIds: [PMCompanyDetails.companyId, ...companyIds], paginator: false })
        // console.log("companyBillAddrResponse===", companyBillAddrResponse)

        if (companyBillAddrResponse.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: companyBillAddrResponse.data.error, life: 3000 }))
        } else {
            let companyBillAddrData = companyBillAddrResponse?.data?.data
            if (companyBillAddrData?.length > 0) {
                companyBillAddrData.map(billAddr => {
                    const relatedState = statesList.find(eachState => eachState.stateId === billAddr.stateId)
                    if (relatedState) {
                        billAddr.stateName = relatedState.stateName
                    }
                    return billAddr
                })
                let buyerCompanyBillAddrData = []
                if(isPermitted){
                    buyerCompanyBillAddrData = companyBillAddrData.filter(eachBillAddr => eachBillAddr.companyId !== PMCompanyDetails.companyId)
                } else {
                    buyerCompanyBillAddrData = companyBillAddrData.filter(eachBillAddr => billAddrIds.includes(eachBillAddr.billAddrId))
                }
                const buyerCompanyPMBillAddrData = companyBillAddrData.filter(eachBillAddr => eachBillAddr.companyId === PMCompanyDetails.companyId)
                setBuyerCompanyBillAddrs(buyerCompanyBillAddrData)
                setBuyerCompanyPMBillAddrs(buyerCompanyPMBillAddrData)

                if (companyBillAddrData.length === 1) {
                    setSelectedBuyerBillAddrId(companyBillAddrData[0].billAddrId)
                }else if (billAddrIds.length === 1){
                    let relatedBillAddress = companyBillAddrData?.find(eachBillAddr => eachBillAddr.billAddrId === billAddrIds[0])
                    setSelectedBuyerBillAddrId(relatedBillAddress?.billAddrId)
                }
            }
        }
    }

    const getCompanyBranchShipAddrsData = async (companyIds, shipAddrIds) => {
        const companyBranchShipAddrResponse = await getCompanyBranchShipAddrs({ companyIds, paginator: false })
        // console.log("companyBranchShipAddrResponse===", companyBranchShipAddrResponse)

        if (companyBranchShipAddrResponse.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: companyBranchShipAddrResponse.data.error, life: 3000 }))
        } else {
            let companyBranchShipAddrData = companyBranchShipAddrResponse?.data?.data
            if (companyBranchShipAddrData?.length > 0) {
                companyBranchShipAddrData.map(shipAddr => {
                    const relatedState = statesList.find(eachState => eachState.stateId === shipAddr.stateId)
                    if (relatedState) {
                        shipAddr.stateName = relatedState.stateName
                    }
                    return shipAddr
                })

                setBuyerCompanyBranchShipAddrs(companyBranchShipAddrData)

                if (companyBranchShipAddrData.length === 1) {
                    setSelectedBuyerShipAddrId(companyBranchShipAddrData[0].shipAddrId)
                }

                if (shipAddrIds?.length === 1) {
                    setSelectedBuyerShipAddrId(shipAddrIds[0])
                }
            }
        }
    }

    const actionMenuItems = [
        {
            label: 'Create Dispatch Note',
            icon: '',
            command: async () => {
                await getSellerGRNQCPunchData()
            },
            permissions: [36]
        },
        {
            label: 'Convert to Stock',
            icon: '',
            command: async () => {
                await getSellerGRNQCPunchDataForConvertToStock()
            },
            permissions: [131]
        }
    ]

    const getBuyerInvoices = async (buyerPOIds) => {
        if (buyerPOIds?.length > 0) {
            let data = {
                buyerPOIds: buyerPOIds
            }
            const response = await getBuyerInvoicesByBuyerPOIds(data)
            console.log("getBuyerInvoices", response)
            if (response.failure) {
                dispatch(raiseToast({ severity: 'error', summary: 'Buyer Invoice', detail: response.data.error, life: 3000 }))
            } else {
                return response?.data
            }
        }
    }

    const getSellerGRNQCPunchData = async () => {
        let canCreateDispatchNote = true

        const invoicingAllowedPMBranchesIds = []
        pmBranches.map(eachPMBranch => {
            if (eachPMBranch.isInvoicingEnabled) {
                invoicingAllowedPMBranchesIds.push(eachPMBranch.branchId)
            }
        })
        const selectedPMBranchIds = selectedDispatchSellerPOs.map(eachSelectedPO => eachSelectedPO.pmBranchId)

        if (!canCreateDispatchNote) {
            return dispatch(raiseToast({ severity: 'error', detail: `Invoicing is disabled` }))
        }

        let stockPOsExist = false 
        selectedDispatchSellerPOs.map(eachSellerPO => {
            if(eachSellerPO.buyerReqOrderTypeId === 3){
                stockPOsExist = true
            }
        })

        if(stockPOsExist){
            return dispatch(raiseToast({ severity: 'error', detail: 'Stock POS cant be dispatched' }))
        }

        setIsLoading(true)
        if (selectedDispatchSellerPOs.length === 0) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'warn', detail: 'Please select dispatch products', life: 3000 }))
        }
        else {
            const relatedBuyerCompanyId = selectedDispatchSellerPOs[0]?.bPOcompanyId
            const relatedBuyerCompanyBranchId = selectedDispatchSellerPOs[0]?.bPObranchId
            const relatedBuyerPMBillAddrId = selectedDispatchSellerPOs[0]?.bPOpmBillAddrId
            const relatedBuyerCompanyTags = selectedDispatchSellerPOs[0]?.tags

            for (let i = 1; i < selectedDispatchSellerPOs.length; i++) {
                if (selectedDispatchSellerPOs[i].bPOcompanyId !== relatedBuyerCompanyId) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: 'Please select same buyer company', life: 3000 }))
                }

                if (selectedDispatchSellerPOs[i]?.bPObranchId !== relatedBuyerCompanyBranchId) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: 'Please select same buyer company branch', life: 3000 }))
                }

                if (selectedDispatchSellerPOs[i]?.bPOpmBillAddrId !== relatedBuyerPMBillAddrId) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: "Please select same buyer po's with same pm bill address", life: 3000 }))
                }
            }

            const relatedBuyerPOIds = []
            selectedDispatchSellerPOs?.map(eachSellerPO => {
                if (eachSellerPO.buyerPOId) {
                    if (!relatedBuyerPOIds.includes(eachSellerPO.buyerPOId)) {
                        relatedBuyerPOIds.push(eachSellerPO.buyerPOId)
                    }
                }
            })

            let buyerInvoicesAndDispatchNoteResponse = await getBuyerInvoices(relatedBuyerPOIds)
            let buyerCreditNoteItems = []
            let buyerReqs = []

            if (buyerInvoicesAndDispatchNoteResponse) {
                let dispatchNotes = buyerInvoicesAndDispatchNoteResponse.dispatchNotes
                let invoiceDispatchMap = buyerInvoicesAndDispatchNoteResponse.invoiceDispatchMap
                let buyerInvoices = buyerInvoicesAndDispatchNoteResponse.buyerInvoice

                buyerReqs = buyerInvoicesAndDispatchNoteResponse.buyerReqs

                let relatedInvoiceDispatchMap = []
                dispatchNotes?.map(eachDispatchNote => {
                    const relatedInvoiceDispatch = invoiceDispatchMap?.filter(eachInvoiceDispatchMap => eachInvoiceDispatchMap?.dispatchNoteId === eachDispatchNote?.dispatchNoteId && eachInvoiceDispatchMap.statusId === 1)
                    if (relatedInvoiceDispatch?.length > 0) {
                        relatedInvoiceDispatchMap = [...relatedInvoiceDispatchMap, ...relatedInvoiceDispatch]
                    }
                })

                let relatedPreviewBuyerInvoicesIds = []
                relatedInvoiceDispatchMap?.map(eachInvoiceDispatchMap => {
                    const relatedBuyerInvoice = buyerInvoices?.find(eachBuyerInvoice => eachBuyerInvoice?.buyerInvoiceId === eachInvoiceDispatchMap?.buyerInvoiceId && !eachBuyerInvoice.docNo)
                    if (relatedBuyerInvoice?.buyerInvoiceId) {
                        relatedPreviewBuyerInvoicesIds.push(relatedBuyerInvoice.buyerInvoiceId)
                    }
                })

                if (buyerInvoicesAndDispatchNoteResponse?.buyerCreditNoteItems?.length > 0) {
                    buyerCreditNoteItems = buyerInvoicesAndDispatchNoteResponse?.buyerCreditNoteItems
                }

                if (relatedPreviewBuyerInvoicesIds?.length > 0) {
                    setIsLoading(false)
                    setPreviewBuyerInvoicesIds(relatedPreviewBuyerInvoicesIds)
                    setIsConfirmPreviewDialogVisible(true)
                    return true
                }
            }

            let buyerPOIds = _.uniqBy(_.map(selectedDispatchSellerPOs, "buyerPOId"))
            let buyerPOItemsResponse = await getBuyerPOItems({ buyerPOIds, statusIds: [3, 4], paginator: false })

            if (buyerPOItemsResponse.failure) {
                return dispatch(raiseToast({ severity: 'warn', detail: buyerPOItemsResponse.data.error, life: 3000 }))
            } else {
                setSelectedBuyerPOItems(buyerPOItemsResponse.data.data)
            }

            let sellerPODocNos = []
            let sellerPOFileNos = []
            let buyerCompanyBillAddrIds = []
            let buyerCompanyBranchShipAddrIds = []
            let companyIds = []
            let sellerPOItemIds = []

            selectedDispatchSellerPOs.map(eachSellerPO => {
                sellerPODocNos.push(eachSellerPO.docNo)
                sellerPOFileNos.push(eachSellerPO.fileNo)
                if (!buyerCompanyBillAddrIds.includes(eachSellerPO.bPObillAddrId)) {
                    buyerCompanyBillAddrIds.push(eachSellerPO.bPObillAddrId)
                }

                if (!buyerCompanyBranchShipAddrIds.includes(eachSellerPO.bPOshipAddrId)) {
                    buyerCompanyBranchShipAddrIds.push(eachSellerPO.bPOshipAddrId)
                }

                if (!companyIds.includes(eachSellerPO.bPOcompanyId)) {
                    companyIds.push(eachSellerPO.bPOcompanyId)
                }

                if (eachSellerPO.sellerPOItems?.length) {
                    eachSellerPO.sellerPOItems.forEach(eachSellerPOItem => {
                        sellerPOItemIds.push(eachSellerPOItem.sellerPOItemId)
                    })
                }
            })

            if (buyerCompanyBillAddrIds.length > 0) {
                getCompanyBillAddrsData(buyerCompanyBillAddrIds, companyIds)
            } else {
                setBuyerCompanyBillAddrs([])
            }

            if (companyIds.length > 0) {
                getCompanyBranchShipAddrsData(companyIds, buyerCompanyBranchShipAddrIds)
            } else {
                setBuyerCompanyBillAddrs([])
            }
            let stockDocRes = await getStockDocsByDocNos({ docNos: sellerPODocNos })

            if (stockDocRes.failure) {
                return dispatch(raiseToast({ severity: 'warn', detail: stockDocRes.data.error, life: 3000 }))
            } else {
                setStockDocs(stockDocParser(stockDocRes.data))
            }
            let stockDocs = stockDocParser(stockDocRes.data)

            const dispatchNoteItemsRes = await getDispatchNoteItemsBySellerPOItemIds({ sellerPOItemIds: sellerPOItemIds, isReinvoicedCNRequired: true })
            if (dispatchNoteItemsRes.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'warn', detail: dispatchNoteItemsRes.data.error }))
            }
            console.log("dispatchNoteItemsRes", dispatchNoteItemsRes)

            const sellerGRNQCPunchAcceptedQtyResponse = await getsellerGRNQCPunchAcceptedQtyForCreateDispatchNote({ sellerPODocNos, sellerPOFileNos })
            console.log("sellerGRNQCPunchAcceptedQty-response", sellerGRNQCPunchAcceptedQtyResponse)
            if (sellerGRNQCPunchAcceptedQtyResponse.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: sellerGRNQCPunchAcceptedQtyResponse.data.error, detail: 'Seller POs not fetched', life: 3000 }))
            } else {
                let sellerPOItems = sellerGRNQCPunchAcceptedQtyResponse.data
                sellerPOItems = _.sortBy(sellerPOItems, 'sellerPOItemId')

                if (sellerPOItems.length > 0) {
                    let buyerReqItemsIds = sellerPOItems.map(sellerPOItem => sellerPOItem.buyerReqItemId)
                    const materialMasterResponse = await getMaterialItemsDataByBuyerReqItemIdsNew({ buyerReqItemsIds: buyerReqItemsIds })

                    setIsLoading(false)

                    if (materialMasterResponse.failure) {
                        return dispatch(raiseToast({ severity: 'warn', detail: materialMasterResponse.data.error, life: 3000 }))
                    } else {
                        let dispatchSellerPOItems = {}
                        for (let i = 0; i < selectedDispatchSellerPOs.length; i++) {
                            let relatedSellerPOItem = sellerPOItems.find(sellerPOItem => sellerPOItem.sellerPOId === selectedDispatchSellerPOs[i].sellerPOId)
                            if (!relatedSellerPOItem) {
                                return dispatch(raiseToast({ severity: 'warn', detail: `PO Punch is not done for seller po ${selectedDispatchSellerPOs[i].docNo}`, life: 3000 }))
                            } else {
                                if (relatedSellerPOItem) {
                                    if (relatedSellerPOItem.acceptedQuantity > 0) {
                                        return dispatch(raiseToast({ severity: 'warn', detail: `Seller PO doesn't is not approved qty`, life: 3000 }))
                                    }
                                }
                            }
                        }

                        sellerPOItems.map(sellerPOItem => {
                            let relatedStockDoc = stockDocs?.find(eachStockDoc => eachStockDoc.docNo === sellerPOItem.docNo && eachStockDoc.materialId === sellerPOItem.materialId && eachStockDoc.statusId === 1)

                            if (!relatedStockDoc.convertedQty) {
                                relatedStockDoc.convertedQty = 0
                            }
                            if (!relatedStockDoc.invoicedQty) {
                                relatedStockDoc.invoicedQty = 0
                            }
                            if (!relatedStockDoc.dispatchedQty) {
                                relatedStockDoc.dispatchedQty = 0
                            }
                            if (!relatedStockDoc.adjustedQty) {
                                relatedStockDoc.adjustedQty = 0
                            }
                            if (!relatedStockDoc.CNDNQty) {
                                relatedStockDoc.CNDNQty = 0
                            }
                            sellerPOItem.totalConvertedQty = relatedStockDoc.convertedQty
                            sellerPOItem.stockDispatchQty = relatedStockDoc.dispatchedQty
                            sellerPOItem.adjustedQty = relatedStockDoc.adjustedQty
                            sellerPOItem.invoicedQty = relatedStockDoc.invoicedQty
                            sellerPOItem.CNDNQty = relatedStockDoc.CNDNQty

                            sellerPOItem.availableDispatchQuantity = (relatedStockDoc.invoicedQty + relatedStockDoc.adjustedQty + relatedStockDoc.CNDNQty - relatedStockDoc.dispatchedQty - relatedStockDoc.convertedQty)
                            sellerPOItem.stockDoc = relatedStockDoc

                            let relatedMaterialItem = materialMasterResponse.data.find(materialItem => materialItem.materialId === sellerPOItem.materialId)
                            if (relatedMaterialItem) {
                                let relatedMaterialBrand = materialBrands.find(eachBrand => eachBrand.brandId === relatedMaterialItem.brandId)
                                if (relatedMaterialBrand) {
                                    sellerPOItem.brandName = relatedMaterialBrand.brandName
                                }

                                const relatedCategory = materialCategories.find(eachIndustry => eachIndustry.categoryId === relatedMaterialItem.categoryId)
                                if (relatedCategory) {
                                    sellerPOItem.categoryId = relatedCategory.categoryId
                                    sellerPOItem.categoryName = relatedCategory.categoryName
                                }
                                sellerPOItem.companyProdName = relatedMaterialItem.companyProdName
                                sellerPOItem.companyProdSpec = relatedMaterialItem.companyProdSpec
                                sellerPOItem.productName = relatedMaterialItem.productName
                                sellerPOItem.variantName = relatedMaterialItem.variantName
                                sellerPOItem.productSpecification = relatedMaterialItem.productSpecification
                                sellerPOItem.UOM = relatedMaterialItem?.UOM
                                sellerPOItem.UOMValue = relatedMaterialItem?.UOMValue
                                sellerPOItem.companyQtyMultiplier = relatedMaterialItem?.companyQtyMultiplier ? relatedMaterialItem?.companyQtyMultiplier : 1
                                sellerPOItem.companyERPUOM = relatedMaterialItem?.companyERPUOM ? relatedMaterialItem?.companyERPUOM : relatedMaterialItem?.UOM
                            }

                            let relatedDispatchSellerPO = selectedDispatchSellerPOs.find(sellerPO => sellerPO.sellerPOId === sellerPOItem.sellerPOId)
                            let relatedBuyerPOItem = buyerPOItemsResponse?.data?.data.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === sellerPOItem.buyerPOItemId)

                            if (relatedBuyerPOItem) {
                                sellerPOItem.bPOGSTRate = relatedBuyerPOItem.bPOGSTRate
                                sellerPOItem.invGSTRate = relatedBuyerPOItem.bPOGSTRate > sellerPOItem.GSTRate ? relatedBuyerPOItem.bPOGSTRate : sellerPOItem.GSTRate
                                sellerPOItem.bPOHSNCode = relatedBuyerPOItem.bPOHSNCode
                                sellerPOItem.invHSNCode = relatedBuyerPOItem.bPOGSTRate > sellerPOItem.GSTRate ? relatedBuyerPOItem.bPOHSNCode : sellerPOItem.HSNCode
                            }

                            relatedDispatchSellerPO = JSON.parse(JSON.stringify(relatedDispatchSellerPO))
                            console.log("relatedDispatchSellerPO", relatedDispatchSellerPO)

                            let relatedBuyerReq = buyerReqs.find(eachBuyerReq => eachBuyerReq.buyerReqId === relatedDispatchSellerPO.buyerReqId)

                            if (relatedDispatchSellerPO) {
                                sellerPOItem.companyId = relatedDispatchSellerPO.companyId
                                sellerPOItem.branchId = relatedDispatchSellerPO.branchId
                                sellerPOItem.billAddrId = relatedDispatchSellerPO.billAddrId
                                sellerPOItem.userId = userId
                                sellerPOItem.buyerReqDocNo = relatedDispatchSellerPO.buyerReqDocNo
                                sellerPOItem.bPOdocNo = relatedDispatchSellerPO.bPOdocNo
                                sellerPOItem.bPOfileNo = relatedDispatchSellerPO.bPOfileNo
                                sellerPOItem.clientPONum = relatedDispatchSellerPO.bPOclientPONum
                                sellerPOItem.bPOpmBillAddrId = relatedDispatchSellerPO.bPOpmBillAddrId
                                sellerPOItem.bPOShipAddrId = relatedDispatchSellerPO.bPOshipAddrId
                                sellerPOItem.clientPONum = relatedDispatchSellerPO.bPOclientPONum
                                sellerPOItem.bPOcompanyId = relatedDispatchSellerPO.bPOcompanyId
                                sellerPOItem.bPObranchId = relatedDispatchSellerPO.bPObranchId
                                sellerPOItem.bPOpmCompanyId = relatedDispatchSellerPO.bPOpmCompanyId
                                sellerPOItem.bPOpmBranchId = relatedDispatchSellerPO.bPOpmBranchId
                                sellerPOItem.bPOcreatedAt = relatedDispatchSellerPO.bPOcreatedAt
                                sellerPOItem.bPOuserId = relatedDispatchSellerPO.bPOuserId
                                sellerPOItem.bPOGSTType = relatedDispatchSellerPO.bPOGSTType
                                sellerPOItem.bPOLogisticsBeforeTax = relatedDispatchSellerPO.bPOLogisticsBeforeTax
                                sellerPOItem.bPORecipientUserId = relatedDispatchSellerPO.bPORecipientUserId
                                sellerPOItem.bQuoteLogisticsOption = relatedDispatchSellerPO.bQuoteLogisticsOption
                                sellerPOItem.catalogAPIReqId = relatedDispatchSellerPO.catalogAPIReqId
                                sellerPOItem.bPOclientPONum = relatedDispatchSellerPO.bPOclientPONum
                                sellerPOItem.bPOpoDocDate = relatedDispatchSellerPO.bPOpoDocDate
                                sellerPOItem.multiPartyFlow = relatedDispatchSellerPO.multiPartyFlow
                                // sellerPOItem.catalogAPIReqId = relatedBuyerReq?.catalogAPIReqId
                            }
                            else {
                                setIsLoading(false)
                                return dispatch(raiseToast({ severity: 'warn', detail: `PI Punch is not done for seller po ${sellerPOItem.docNo}`, life: 3000 }))
                            }

                            let relatedSellerPIPunchDetails = sellerPOItem.sellerPIPunchDetails.map(eachSellerPIPunch => {
                                return { ...eachSellerPIPunch, availablePIPunchQty: eachSellerPIPunch.qty }
                            })

                            if (dispatchNoteItemsRes.data.adjustmentNoteItems) {
                                relatedSellerPIPunchDetails = relatedSellerPIPunchDetails.map(eachSellerPIPunch => {
                                    const relatedAdjustmentNoteItems = dispatchNoteItemsRes.data.adjustmentNoteItems.filter(eachAdjustmentNote => eachAdjustmentNote.sellerPIPunchItemId === eachSellerPIPunch.sellerPIPunchItemId)
                                    if (relatedAdjustmentNoteItems.length) {
                                        const totalAdjustmentQty = relatedAdjustmentNoteItems.reduce((acc, curr) => acc + parseFloat(curr.adjustedQty), 0)
                                        return {
                                            ...eachSellerPIPunch,
                                            availablePIPunchQty: round(totalAdjustmentQty + parseFloat(eachSellerPIPunch.availablePIPunchQty), 3)
                                        }
                                    }
                                    return eachSellerPIPunch
                                })
                            }

                            if (dispatchNoteItemsRes.data?.dispatchNoteItems?.length) {
                                const relatedDispatchNoteItems = _.sortBy(dispatchNoteItemsRes.data.dispatchNoteItems.filter(eachDispatchNoteItem => eachDispatchNoteItem.sellerPOItemId === sellerPOItem.sellerPOItemId), 'createdAt')

                                let sellerPIPunchItemQtyMap = {}
                                relatedSellerPIPunchDetails.forEach(eachPIPunchItem => { sellerPIPunchItemQtyMap[eachPIPunchItem.sellerPIPunchItemId] = eachPIPunchItem.availablePIPunchQty })

                                relatedDispatchNoteItems.forEach(eachDispatchNoteItem => {
                                    let remainingQty = parseFloat(eachDispatchNoteItem.qty)
                                    const usedSellerPIPunchItemIds = _.sortBy(eachDispatchNoteItem.sellerPIPunchItemId) || []

                                    usedSellerPIPunchItemIds.forEach(eachSellerPIPunchId => {
                                        if (remainingQty > 0) {
                                            let availableSellerPIPunchItemQty = parseFloat(sellerPIPunchItemQtyMap[eachSellerPIPunchId])

                                            if (availableSellerPIPunchItemQty > 0) {
                                                const consumedQty = Math.min(availableSellerPIPunchItemQty, remainingQty)
                                                sellerPIPunchItemQtyMap[eachSellerPIPunchId] -= consumedQty
                                                remainingQty -= consumedQty
                                            }
                                        }
                                    })
                                })

                                relatedSellerPIPunchDetails = relatedSellerPIPunchDetails.map(eachSellerPIPunch => {
                                    if (eachSellerPIPunch.sellerPIPunchItemId in sellerPIPunchItemQtyMap) {
                                        return {
                                            ...eachSellerPIPunch,
                                            availablePIPunchQty: round(sellerPIPunchItemQtyMap[eachSellerPIPunch.sellerPIPunchItemId], 3)
                                        }
                                    }
                                    return eachSellerPIPunch
                                })
                            }

                            relatedSellerPIPunchDetails = relatedSellerPIPunchDetails.map(eachSellerPIPunch => {
                                return { ...eachSellerPIPunch, availablePIPunchQty: eachSellerPIPunch.availablePIPunchQty > 0 ? eachSellerPIPunch.availablePIPunchQty : 0 }
                            })
                            sellerPOItem.sellerPIPunchDetails = relatedSellerPIPunchDetails

                            let groupingItemId = sellerPOItem.buyerReqItemId

                            if (relatedBuyerCompanyTags?.groupBuyerInvoiceItemsBy){
                                groupingItemId = sellerPOItem[relatedBuyerCompanyTags.groupBuyerInvoiceItemsBy]
                            }

                            if (!dispatchSellerPOItems[groupingItemId]) {
                                dispatchSellerPOItems[groupingItemId] = []
                            }

                            if(sellerPOItem.sellerPIPunchDetails?.length === 1 && sellerPOItem.sellerPIPunchDetails.verifiedBy){
                                sellerPOItem.sellerPIPunchItemId = sellerPOItem.sellerPIPunchDetails.map(eachSellerPIPunch => eachSellerPIPunch.sellerPIPunchItemId)
                            }

                            dispatchSellerPOItems[groupingItemId].push(JSON.parse(JSON.stringify(sellerPOItem)))
                        })

                        // let sellerPOMaterialIdMappedArr = []
                        // Object.keys(dispatchSellerPOItems).forEach(eachReqItemId => {
                        //     const relatedSellerPOItems = dispatchSellerPOItems[eachReqItemId]

                        //     relatedSellerPOItems.forEach(eachSelPOItem => {
                        //         const relatedSellerPOMaterialId = sellerPOMaterialIdMappedArr.find(eachSellerPOMaterialIdMappedObj =>
                        //             eachSelPOItem.docNo === eachSellerPOMaterialIdMappedObj.sellerPODocNo
                        //             && eachSelPOItem.materialId === eachSellerPOMaterialIdMappedObj.materialId
                        //         )

                        //         if (!relatedSellerPOMaterialId) {
                        //             const newSellerPOMaterialIdMappedObj = {
                        //                 sellerPODocNo: eachSelPOItem.docNo,
                        //                 materialId: eachSelPOItem.materialId,
                        //                 maxAvailableQty: eachSelPOItem.availableDispatchQuantity
                        //             }
                        //             sellerPOMaterialIdMappedArr = [...sellerPOMaterialIdMappedArr, newSellerPOMaterialIdMappedObj]
                        //         }
                        //     })

                        //     relatedSellerPOItems.forEach(eachSelPOItem => {
                        //         const sellerPOMaterialIdMappedObj = sellerPOMaterialIdMappedArr.find(eachSellerPOMaterialIdMappedObj =>
                        //             eachSellerPOMaterialIdMappedObj.materialId === eachSelPOItem.materialId
                        //             && eachSellerPOMaterialIdMappedObj.sellerPODocNo === eachSelPOItem.docNo
                        //         )
                        //         if (sellerPOMaterialIdMappedObj.maxAvailableQty > 0) {
                        //             if (parseFloat(sellerPOMaterialIdMappedObj.maxAvailableQty) - parseFloat(eachSelPOItem.totalAcceptedQuantity) >= 0) {
                        //                 eachSelPOItem.availableDispatchQuantity = parseFloat(eachSelPOItem.totalAcceptedQuantity)
                        //                 sellerPOMaterialIdMappedArr = sellerPOMaterialIdMappedArr.map(eachSellerPOMaterialIdMappedObj => {
                        //                     if (eachSellerPOMaterialIdMappedObj.sellerPODocNo === sellerPOMaterialIdMappedObj.sellerPODocNo && eachSellerPOMaterialIdMappedObj.materialId === sellerPOMaterialIdMappedObj.materialId) {
                        //                         return { ...eachSellerPOMaterialIdMappedObj, maxAvailableQty: parseFloat(sellerPOMaterialIdMappedObj.maxAvailableQty) - parseFloat(eachSelPOItem.totalAcceptedQuantity) }
                        //                     }
                        //                     return eachSellerPOMaterialIdMappedObj
                        //                 })
                        //             }
                        //             else {
                        //                 eachSelPOItem.availableDispatchQuantity = parseFloat(sellerPOMaterialIdMappedObj.maxAvailableQty)
                        //                 sellerPOMaterialIdMappedArr = sellerPOMaterialIdMappedArr.map(eachSellerPOMaterialIdMappedObj => {
                        //                     if (eachSellerPOMaterialIdMappedObj.sellerPODocNo === sellerPOMaterialIdMappedObj.sellerPODocNo && eachSellerPOMaterialIdMappedObj.materialId === sellerPOMaterialIdMappedObj.materialId) {
                        //                         return { ...eachSellerPOMaterialIdMappedObj, maxAvailableQty: 0 }
                        //                     }
                        //                     return eachSellerPOMaterialIdMappedObj
                        //                 })
                        //             }
                        //         }
                        //         else {
                        //             eachSelPOItem.availableDispatchQuantity = 0
                        //         }
                        //     })
                        // })

                        console.log("dispatchSellerPOItems", dispatchSellerPOItems)

                        setSelectedDispatchSellerPOItems(dispatchSellerPOItems)
                        setIsCreateDispatchNoteVisible(true)
                    }
                }
                else {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: "Selected seller po's doesn't have PI Punch", life: 3000 }))
                }
            }
            setIsLoading(false)
        }
    }

    const getSellerGRNQCPunchDataForConvertToStock = async () => {
        let stockPOsExist = false 
        selectedDispatchSellerPOs.map(eachSellerPO => {
            if(eachSellerPO.buyerReqOrderTypeId === 3){
                stockPOsExist = true
            }
        })

        if(stockPOsExist){
            return dispatch(raiseToast({ severity: 'error', detail: 'Stock POS cant be converted to stock' }))
        }

        setIsLoading(true)
        if (selectedDispatchSellerPOs.length === 0) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'warn', detail: 'Please select dispatch products', life: 3000 }))
        }
        else {

            const relatedBuyerCompanyId = selectedDispatchSellerPOs[0]?.bPOcompanyId
            const relatedBuyerCompanyBranchId = selectedDispatchSellerPOs[0]?.bPObranchId
            const relatedBuyerPMBillAddrId = selectedDispatchSellerPOs[0]?.bPOpmBillAddrId

            for (let i = 1; i < selectedDispatchSellerPOs.length; i++) {
                if (selectedDispatchSellerPOs[i]?.bPOcompanyId !== relatedBuyerCompanyId) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: 'Please select same buyer company', life: 3000 }))
                }

                if (selectedDispatchSellerPOs[i]?.bPObranchId !== relatedBuyerCompanyBranchId) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: 'Please select same buyer company branch', life: 3000 }))
                }

                if (selectedDispatchSellerPOs[i]?.bPOpmBillAddrId !== relatedBuyerPMBillAddrId) {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: "Please select same buyer po's with same pm bill address", life: 3000 }))
                }
            }

            const relatedBuyerPOIds = []
            selectedDispatchSellerPOs?.map(eachSellerPO => {
                if (eachSellerPO?.buyerPOId) {
                    if (!relatedBuyerPOIds.includes(eachSellerPO.buyerPOId)) {
                        relatedBuyerPOIds.push(eachSellerPO.buyerPOId)
                    }
                }
            })

            let buyerInvoicesAndDispatchNoteResponse = await getBuyerInvoices(relatedBuyerPOIds)
            let buyerCreditNoteItems = []

            if (buyerInvoicesAndDispatchNoteResponse) {
                let dispatchNotes = buyerInvoicesAndDispatchNoteResponse.dispatchNotes
                let invoiceDispatchMap = buyerInvoicesAndDispatchNoteResponse.invoiceDispatchMap
                let buyerInvoices = buyerInvoicesAndDispatchNoteResponse.buyerInvoice

                let relatedInvoiceDispatchMap = []
                dispatchNotes?.map(eachDispatchNote => {
                    const relatedInvoiceDispatch = invoiceDispatchMap?.filter(eachInvoiceDispatchMap => eachInvoiceDispatchMap?.dispatchNoteId === eachDispatchNote?.dispatchNoteId && eachInvoiceDispatchMap.statusId === 1)
                    if (relatedInvoiceDispatch?.length > 0) {
                        relatedInvoiceDispatchMap = [...relatedInvoiceDispatchMap, ...relatedInvoiceDispatch]
                    }
                })

                let relatedPreviewBuyerInvoicesIds = []
                relatedInvoiceDispatchMap?.map(eachInvoiceDispatchMap => {
                    const relatedBuyerInvoice = buyerInvoices?.find(eachBuyerInvoice => eachBuyerInvoice?.buyerInvoiceId === eachInvoiceDispatchMap?.buyerInvoiceId && !eachBuyerInvoice.docNo)
                    if (relatedBuyerInvoice?.buyerInvoiceId) {
                        relatedPreviewBuyerInvoicesIds.push(relatedBuyerInvoice.buyerInvoiceId)
                    }
                })

                if (buyerInvoicesAndDispatchNoteResponse?.buyerCreditNoteItems?.length > 0) {
                    buyerCreditNoteItems = buyerInvoicesAndDispatchNoteResponse?.buyerCreditNoteItems
                }

                if (relatedPreviewBuyerInvoicesIds?.length > 0) {
                    setIsLoading(false)
                    setPreviewBuyerInvoicesIds(relatedPreviewBuyerInvoicesIds)
                    setIsConfirmPreviewDialogVisible(true)
                    return true
                    //return dispatch(raiseToast({ severity: 'error', detail: 'Preview Invoice was already generated. Please cancelled', life: 3000 }))
                }
            }

            let sellerPODocNos = []
            let sellerPOFileNos = []
            let companyIds = []
            let buyerCompanyBillAddrIds = []
            let buyerCompanyBranchShipAddrIds = []

            selectedDispatchSellerPOs.map(eachSellerPO => {
                sellerPODocNos.push(eachSellerPO.docNo)
                sellerPOFileNos.push(eachSellerPO.fileNo)
                if (!buyerCompanyBillAddrIds.includes(eachSellerPO.bPObillAddrId)) {
                    buyerCompanyBillAddrIds.push(eachSellerPO.bPObillAddrId)
                }

                if (!buyerCompanyBranchShipAddrIds.includes(eachSellerPO.bPOshipAddrId)) {
                    buyerCompanyBranchShipAddrIds.push(eachSellerPO.bPOshipAddrId)
                }

                if (!companyIds.includes(eachSellerPO?.bPOcompanyId)) {
                    companyIds.push(eachSellerPO?.bPOcompanyId)
                }
            })

            if (buyerCompanyBillAddrIds.length > 0) {
                getCompanyBillAddrsData(buyerCompanyBillAddrIds, companyIds)
            } else {
                setBuyerCompanyBillAddrs([])
            }

            if (companyIds.length > 0) {
                getCompanyBranchShipAddrsData(companyIds)
            } else {
                setBuyerCompanyBillAddrs([])
            }

            let stockDocRes = await getStockDocsByDocNos({ docNos: sellerPODocNos })
            // console.log("stockDocRes", stockDocRes)
            if (stockDocRes.failure) {
                return dispatch(raiseToast({ severity: 'warn', detail: stockDocRes.data.error, life: 3000 }))
            } else {
                setStockDocs(stockDocParser(stockDocRes.data))
            }
            let stockDocs = stockDocParser(stockDocRes.data)
            const sellerGRNQCPunchAcceptedQtyResponse = await getsellerGRNQCPunchAcceptedQtyForCreateDispatchNote({ sellerPODocNos, sellerPOFileNos })
            // console.log("getsellerGRNQCPunchAcceptedQty-response", sellerGRNQCPunchAcceptedQtyResponse)

            if (sellerGRNQCPunchAcceptedQtyResponse.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: sellerGRNQCPunchAcceptedQtyResponse.data.error, detail: 'Seller POs not fetched', life: 3000 }))
            } else {
                let sellerPOItems = sellerGRNQCPunchAcceptedQtyResponse.data
                if (sellerPOItems.length > 0) {
                    let buyerReqItemsIds = sellerPOItems.map(sellerPOItem => sellerPOItem.buyerReqItemId)
                    const materialMasterResponse = await getMaterialItemsDataByBuyerReqItemIdsNew({ buyerReqItemsIds: buyerReqItemsIds })
                    // console.log("materialMaster-response", materialMasterResponse)
                    setIsLoading(false)
                    if (materialMasterResponse.failure) {
                        return dispatch(raiseToast({ severity: 'warn', detail: materialMasterResponse.data.error, life: 3000 }))
                    } else {
                        let dispatchSellerPOItems = {}
                        for (let i = 0; i < selectedDispatchSellerPOs.length; i++) {
                            let relatedSellerPOItem = sellerPOItems.find(sellerPOItem => sellerPOItem.sellerPOId === selectedDispatchSellerPOs[i].sellerPOId)
                            if (!relatedSellerPOItem) {
                                return dispatch(raiseToast({ severity: 'warn', detail: `PO Punch is not done for seller po ${selectedDispatchSellerPOs[i].docNo}`, life: 3000 }))
                            } else {
                                if (relatedSellerPOItem) {
                                    if (relatedSellerPOItem.acceptedQuantity > 0) {
                                        return dispatch(raiseToast({ severity: 'warn', detail: `Seller PO doesn't is not approved qty`, life: 3000 }))
                                    }
                                }
                            }
                        }

                        sellerPOItems.map(sellerPOItem => {
                            let relatedStockDoc = stockDocs.find(eachStockDoc => eachStockDoc?.docNo === sellerPOItem?.docNo && eachStockDoc?.materialId === sellerPOItem?.materialId && eachStockDoc?.statusId === 1)

                            if (!relatedStockDoc.invoicedQty) {
                                relatedStockDoc.invoicedQty = 0
                            }
                            if (!relatedStockDoc.convertedQty) {
                                relatedStockDoc.convertedQty = 0
                            }
                            if (!relatedStockDoc.dispatchedQty) {
                                relatedStockDoc.dispatchedQty = 0
                            }
                            if (!relatedStockDoc.adjustedQty) {
                                relatedStockDoc.adjustedQty = 0
                            }
                            if (!relatedStockDoc.CNDNQty) {
                                relatedStockDoc.CNDNQty = 0
                            }

                            sellerPOItem.totalConvertedQty = relatedStockDoc.convertedQty
                            sellerPOItem.stockDispatchQty = relatedStockDoc.dispatchedQty
                            sellerPOItem.adjustedQty = relatedStockDoc.adjustedQty
                            sellerPOItem.invoicedQty = relatedStockDoc.invoicedQty
                            sellerPOItem.CNDNQty = relatedStockDoc.CNDNQty
                            sellerPOItem.stockDoc = relatedStockDoc

                            sellerPOItem.availableDispatchQuantity = (relatedStockDoc.invoicedQty + relatedStockDoc.adjustedQty + relatedStockDoc.CNDNQty - relatedStockDoc.dispatchedQty - relatedStockDoc.convertedQty)

                            let relatedMaterialItem = materialMasterResponse.data.find(materialItem => materialItem.materialId === sellerPOItem.materialId)
                            if (relatedMaterialItem) {
                                let relatedMaterialBrand = materialBrands.find(eachBrand => eachBrand.brandId === relatedMaterialItem.brandId)
                                if (relatedMaterialBrand) {
                                    sellerPOItem.brandName = relatedMaterialBrand.brandName
                                }

                                const relatedCategory = materialCategories.find(eachIndustry => eachIndustry.categoryId === relatedMaterialItem.categoryId)
                                if (relatedCategory) {
                                    sellerPOItem.categoryName = relatedCategory.categoryName
                                }
                                sellerPOItem.companyProdName = relatedMaterialItem.companyProdName
                                sellerPOItem.companyProdSpec = relatedMaterialItem.companyProdSpec
                                sellerPOItem.productName = relatedMaterialItem.productName
                                sellerPOItem.variantName = relatedMaterialItem.variantName
                                sellerPOItem.productSpecification = relatedMaterialItem.productSpecification
                                sellerPOItem.UOM = relatedMaterialItem?.UOM
                            }

                            let relatedDispatchSellerPO = selectedDispatchSellerPOs.find(sellerPO => sellerPO.sellerPOId === sellerPOItem.sellerPOId)

                            relatedDispatchSellerPO = JSON.parse(JSON.stringify(relatedDispatchSellerPO))

                            if (relatedDispatchSellerPO) {
                                sellerPOItem.companyId = relatedDispatchSellerPO.companyId
                                sellerPOItem.branchId = relatedDispatchSellerPO.branchId
                                sellerPOItem.billAddrId = relatedDispatchSellerPO.billAddrId
                                sellerPOItem.userId = userId
                                sellerPOItem.buyerReqDocNo = relatedDispatchSellerPO.buyerReqDocNo
                                sellerPOItem.bPOdocNo = relatedDispatchSellerPO.bPOdocNo
                                sellerPOItem.bPOfileNo = relatedDispatchSellerPO.bPOfileNo
                                sellerPOItem.clientPONum = relatedDispatchSellerPO.bPOclientPONum
                                sellerPOItem.bPOpmBillAddrId = relatedDispatchSellerPO.bPOpmBillAddrId
                                sellerPOItem.bPOShipAddrId = relatedDispatchSellerPO.bPOshipAddrId
                                sellerPOItem.bPOcompanyId = relatedDispatchSellerPO.bPOcompanyId
                                sellerPOItem.bPObranchId = relatedDispatchSellerPO.bPObranchId
                                sellerPOItem.bPOpmCompanyId = relatedDispatchSellerPO.bPOpmCompanyId
                                sellerPOItem.bPOpmBranchId = relatedDispatchSellerPO.bPOpmBranchId
                                sellerPOItem.bPOcreatedAt = relatedDispatchSellerPO.bPOcreatedAt
                                sellerPOItem.bPOuserId = relatedDispatchSellerPO.bPOuserId
                                sellerPOItem.bPOGSTType = relatedDispatchSellerPO.bPOGSTType
                                sellerPOItem.bPOLogisticsBeforeTax = relatedDispatchSellerPO.bPOLogisticsBeforeTax
                                sellerPOItem.bPORecipientUserId = relatedDispatchSellerPO.bPORecipientUserId
                                sellerPOItem.bQuoteLogisticsOption = relatedDispatchSellerPO.bQuoteLogisticsOption
                                sellerPOItem.bPOclientPONum = relatedDispatchSellerPO.bPOclientPONum
                                sellerPOItem.bPOpoDocDate = relatedDispatchSellerPO.bPOpoDocDate
                                sellerPOItem.multiPartyFlow = relatedDispatchSellerPO.multiPartyFlow
                            }
                            else {
                                setIsLoading(false)
                                return dispatch(raiseToast({ severity: 'warn', detail: `PI Punch is not done for seller po ${sellerPOItem.docNo}`, life: 3000 }))
                            }

                            if (!dispatchSellerPOItems[sellerPOItem.buyerReqItemId]) {
                                dispatchSellerPOItems[sellerPOItem.buyerReqItemId] = [];
                            }
                            dispatchSellerPOItems[sellerPOItem.buyerReqItemId].push(JSON.parse(JSON.stringify(sellerPOItem)))
                        })

                        // let sellerPOMaterialIdMappedArr = []
                        // Object.keys(dispatchSellerPOItems).forEach(eachReqItemId => {
                        //     const relatedSellerPOItems = dispatchSellerPOItems[eachReqItemId]

                        //     relatedSellerPOItems.forEach(eachSelPOItem => {
                        //         const relatedSellerPOMaterialId = sellerPOMaterialIdMappedArr.find(eachSellerPOMaterialIdMappedObj => 
                        //             eachSelPOItem.docNo === eachSellerPOMaterialIdMappedObj.sellerPODocNo 
                        //             && eachSelPOItem.materialId === eachSellerPOMaterialIdMappedObj.materialId
                        //         )

                        //         if(!relatedSellerPOMaterialId){
                        //             const newSellerPOMaterialIdMappedObj = {
                        //                 sellerPODocNo: eachSelPOItem.docNo,
                        //                 materialId: eachSelPOItem.materialId,
                        //                 maxAvailableQty: eachSelPOItem.availableDispatchQuantity
                        //             }
                        //             sellerPOMaterialIdMappedArr = [...sellerPOMaterialIdMappedArr, newSellerPOMaterialIdMappedObj]
                        //         }
                        //     })

                        //     relatedSellerPOItems.forEach(eachSelPOItem => {
                        //         const sellerPOMaterialIdMappedObj = sellerPOMaterialIdMappedArr.find(eachSellerPOMaterialIdMappedObj => 
                        //             eachSellerPOMaterialIdMappedObj.materialId === eachSelPOItem.materialId 
                        //             && eachSellerPOMaterialIdMappedObj.sellerPODocNo === eachSelPOItem.docNo
                        //         )
                        //         if(sellerPOMaterialIdMappedObj.maxAvailableQty > 0){
                        //             if(parseFloat(sellerPOMaterialIdMappedObj.maxAvailableQty) - (parseFloat(eachSelPOItem.invoicedQty) + parseFloat(eachSelPOItem.CNDNQty) + parseFloat(eachSelPOItem.adjustedQty)) >= 0){
                        //                 eachSelPOItem.availableDispatchQuantity = parseFloat(eachSelPOItem.invoicedQty) + parseFloat(eachSelPOItem.CNDNQty) + parseFloat(eachSelPOItem.adjustedQty)
                        //                 sellerPOMaterialIdMappedArr = sellerPOMaterialIdMappedArr.map(eachSellerPOMaterialIdMappedObj => {
                        //                     if(eachSellerPOMaterialIdMappedObj.sellerPODocNo === sellerPOMaterialIdMappedObj.sellerPODocNo && eachSellerPOMaterialIdMappedObj.materialId === sellerPOMaterialIdMappedObj.materialId){
                        //                         return {...eachSellerPOMaterialIdMappedObj, maxAvailableQty: parseFloat(sellerPOMaterialIdMappedObj.maxAvailableQty) - parseFloat(eachSelPOItem.invoicedQty) + parseFloat(eachSelPOItem.CNDNQty) + parseFloat(eachSelPOItem.adjustedQty)}
                        //                     }
                        //                     return eachSellerPOMaterialIdMappedObj
                        //                 })
                        //             }
                        //             else{
                        //                 eachSelPOItem.availableDispatchQuantity = parseFloat(sellerPOMaterialIdMappedObj.maxAvailableQty)
                        //                 sellerPOMaterialIdMappedArr = sellerPOMaterialIdMappedArr.map(eachSellerPOMaterialIdMappedObj => {
                        //                     if(eachSellerPOMaterialIdMappedObj.sellerPODocNo === sellerPOMaterialIdMappedObj.sellerPODocNo && eachSellerPOMaterialIdMappedObj.materialId === sellerPOMaterialIdMappedObj.materialId){
                        //                         return {...eachSellerPOMaterialIdMappedObj, maxAvailableQty: 0}
                        //                     }
                        //                     return eachSellerPOMaterialIdMappedObj
                        //                 })
                        //             }
                        //         }
                        //         else{
                        //             eachSelPOItem.availableDispatchQuantity = 0
                        //         }
                        //     })
                        // })

                        // console.log("dispatchSellerPOItems", dispatchSellerPOItems)

                        setSelectedDispatchSellerPOItems(dispatchSellerPOItems)
                        setIsCovertToStockVisible(true)
                    }
                }
                else {
                    setIsLoading(false)
                    return dispatch(raiseToast({ severity: 'warn', detail: "Selected seller po's doesn't have PI Punch", life: 3000 }))
                }
            }
            setIsLoading(false)

            let buyerPOIds = _.uniqBy(_.map(selectedDispatchSellerPOs, "buyerPOId"))
            let buyerPOItemsResponse = await getBuyerPOItems({ buyerPOIds, statusIds: [3, 4] })

            if (buyerPOItemsResponse.failure) {
                return dispatch(raiseToast({ severity: 'warn', detail: buyerPOItemsResponse.data.error, life: 3000 }))
            } else {
                setSelectedBuyerPOItems(buyerPOItemsResponse.data.data)
            }
        }
    }


    const getLogisticsPartnersData = async () => {
        let logisticsPartnersResponse = await getLogisticsPartners({ sortBy: 'partnerName', paginator: false })

        if (logisticsPartnersResponse.failure) {
            return dispatch(raiseToast({ severity: 'warn', detail: logisticsPartnersResponse.data.error, life: 3000 }))
        } else {
            let logistcsPartnersData = logisticsPartnersResponse?.data?.data
            const uniquePartners = {}
            let uniqueLogisticsPartnersData = []
            logistcsPartnersData.map(eachLogisticPartner => {
                let relatedState = statesList.find(eachState => eachState.stateId === eachLogisticPartner.stateId)
                if (relatedState) {
                    //eachLogisticPartner.partnerNameWithState = eachLogisticPartner.partnerName + "_" + relatedState.stateName
                    const partnerNameWithState = eachLogisticPartner.partnerName + "_" + relatedState.stateName
                    if (!uniquePartners[partnerNameWithState]) {
                        uniquePartners[partnerNameWithState] = true
                        eachLogisticPartner.partnerNameWithState = partnerNameWithState
                        uniqueLogisticsPartnersData.push(eachLogisticPartner)
                    }
                } else {
                    //eachLogisticPartner.partnerNameWithState = eachLogisticPartner.partnerName
                    eachLogisticPartner.partnerNameWithState = eachLogisticPartner.partnerName;
                    uniqueLogisticsPartnersData.push(eachLogisticPartner)
                }
            })

            //setLogisticPartners(logistcsPartnersData)
            setLogisticPartners(uniqueLogisticsPartnersData)
        }
    }

    const handleSubmitCreateDispatch = async (dispatchSellerPOItems, logisticAmount, trackingDetails, isGenerateInvoice, supplyType, logisticsHSNCode, totalBuyerPOLogisticAmount, recipientUser, vehicleNo, dispatchSellerPOs, isLogisticsDeliveryAtActuals, itemsGroupedBy, suppliedToExporter, TCSRate, biofuelActivityType, showBiofuelActivityType) => {

        const pmCompanyConfig = getPMCompanyConfig(dispatchSellerPOs[0].pmCompanyId)

        if (pmCompanyConfig.defaultHSNCode){
            logisticsHSNCode = pmCompanyConfig.defaultHSNCode
        }

        let dispatchSellerPOItemsArr = Object.values(dispatchSellerPOItems).flat()
        let isSellerPOItemDispatchQtyEnters = dispatchSellerPOItemsArr.some(eachSellerPOItem => eachSellerPOItem.dispatchQty > 0)

        if (!isSellerPOItemDispatchQtyEnters) {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Please enter dispatch qty for any item', life: 3000 }))
        }

        if (!selectedBuyerBillAddrId) {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Please select billing address', life: 3000 }))
        }
        if (!selectedBuyerShipAddrId) {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Please select shipping address', life: 3000 }))
        }

        let isUOMUnavailable = false
        Object.keys(dispatchSellerPOItems).map(eachDispatchSellerPOItemId => {
            if (dispatchSellerPOItems[eachDispatchSellerPOItemId]?.length > 0) {
                dispatchSellerPOItems[eachDispatchSellerPOItemId].map(eachObj => {
                    if (eachObj.materialId) {
                        const relatedMaterialDetail = materialDetails.find(eachMaterial => eachMaterial.materialId === eachObj.materialId)
                        if (!relatedMaterialDetail.UOM) {
                            isUOMUnavailable = true
                        }
                    }
                })
            }
        })
        
        if (isUOMUnavailable) {
            return dispatch(raiseToast({ severity: 'error', detail: 'UOM is missing! please contact tech team', life: 3000 }))
        }

        let newDispatchNote = null

        const relatedSellerPOItems = dispatchSellerPOItemsArr.filter(eachSellerPOItem => eachSellerPOItem.dispatchQty > 0)

        let buyerPONumbers = []
        let latestBuyerPODate = null
        let sellerPOMaterialIdMappedArr = []
        relatedSellerPOItems.forEach(eachSellerPOItem => {
            const relatedSellerPOMaterialId = sellerPOMaterialIdMappedArr.find(eachSellerPOMaterialId => eachSellerPOMaterialId.sellerPODocNo === eachSellerPOItem.docNo
                && eachSellerPOMaterialId.materialId === eachSellerPOItem.materialId
            )

            if(!relatedSellerPOMaterialId){
                const newSellerPOMaterialIdMappedObj = {
                    sellerPODocNo: eachSellerPOItem.docNo,
                    materialId: eachSellerPOItem.materialId,
                    availableDispatchQuantity: parseFloat(eachSellerPOItem.availableDispatchQuantity),
                    dispatchQty: eachSellerPOItem.dispatchQty
                }
                sellerPOMaterialIdMappedArr = [...sellerPOMaterialIdMappedArr, newSellerPOMaterialIdMappedObj]
            }
            else{
                sellerPOMaterialIdMappedArr = sellerPOMaterialIdMappedArr.map(eachSelPOMap => {
                    if(eachSelPOMap.sellerPODocNo === eachSellerPOItem.docNo && eachSelPOMap.materialId === eachSellerPOItem.materialId){
                        return {...eachSelPOMap, dispatchQty: parseFloat(eachSellerPOItem.dispatchQty) + parseFloat(eachSelPOMap.dispatchQty)}
                    }
                    return eachSelPOMap
                })
            }

            if (eachSellerPOItem.bPOclientPONum) {
                if (!buyerPONumbers.includes(eachSellerPOItem.bPOclientPONum)) {
                    buyerPONumbers.push(eachSellerPOItem.bPOclientPONum)
                }
            }

            if (eachSellerPOItem.bPOpoDocDate) {
                if (!latestBuyerPODate) {
                    latestBuyerPODate = eachSellerPOItem.bPOpoDocDate
                }
                else {
                    if (eachSellerPOItem.bPOpoDocDate > latestBuyerPODate) {
                        latestBuyerPODate = eachSellerPOItem.bPOpoDocDate
                    }
                }
            }
        })
        
        const invalidQtyMaterial = sellerPOMaterialIdMappedArr.find(eachSellerPOMaterialId => {
            if(eachSellerPOMaterialId.dispatchQty > eachSellerPOMaterialId.availableDispatchQuantity){
                return true
            }
            return false
        })

        if(invalidQtyMaterial){
            return dispatch(raiseToast({ severity: 'warn', detail: `Total accepted qty for material ${invalidQtyMaterial.materialId}(${invalidQtyMaterial.sellerPODocNo}) is ${invalidQtyMaterial.availableDispatchQuantity} Only, tried to dispatch ${invalidQtyMaterial.dispatchQty} qty!`, life: 3000 }))
        }

        if(showBiofuelActivityType){
            if(!biofuelActivityType){
                return dispatch(raiseToast({ severity: 'warn', detail: 'Please select biofuel activity type' }))
            }
        }

        const relatedBuyerPOmaxDateDocNoAndFileNo = relatedSellerPOItems.reduce((max, current) => {
            const currentDate = current.bPOcreatedAt;

            if (currentDate > max.bPOcreatedAt) {
                return { date: currentDate, fileNo: current.bPOfileNo, docNo: current.bPOdocNo, GSTType: current.bPOGSTType, userId: current.bPOuserId };
            } else {
                return max;
            }
        }, { createdAt: relatedSellerPOItems[0]?.bPOcreatedAt, docNo: relatedSellerPOItems[0]?.bPOdocNo, fileNo: relatedSellerPOItems[0]?.bPOfileNo, GSTType: relatedSellerPOItems[0]?.bPOGSTType, userId: relatedSellerPOItems[0]?.bPOuserId });

        if (relatedSellerPOItems.length > 0) {
            const relatedBuyerBillAddr = buyerCompanyBillAddrs.find(eachAddr => eachAddr.billAddrId === selectedBuyerBillAddrId)
            const pmCompanyBillAddrDetails = buyerCompanyPMBillAddrs.find(eachBillAddr => eachBillAddr.billAddrId === relatedSellerPOItems[0].bPOpmBillAddrId)

            let isIGST = relatedBuyerBillAddr?.stateId === pmCompanyBillAddrDetails?.stateId ? false : true

            if(pmCompanyBillAddrDetails.gstinCode && !["URP", "URD"].includes(pmCompanyBillAddrDetails.gstinCode) && relatedBuyerBillAddr.gstinCode && !["URP", "URD"].includes(relatedBuyerBillAddr.gstinCode)){
                isIGST = parseInt(pmCompanyBillAddrDetails.gstinCode.slice(0, 2)) !== parseInt(relatedBuyerBillAddr.gstinCode.slice(0, 2))
            }
            newDispatchNote = {
                docNo: relatedBuyerPOmaxDateDocNoAndFileNo.docNo,
                fileNo: relatedBuyerPOmaxDateDocNoAndFileNo.fileNo,
                supplyTypeId: isGenerateInvoice ? supplyType : null,
                companyId: relatedSellerPOItems[0].bPOcompanyId,
                branchId: relatedSellerPOItems[0].bPObranchId,
                pmCompanyId: relatedSellerPOItems[0].bPOpmCompanyId,
                pmBranchId: relatedSellerPOItems[0].bPOpmBranchId,
                billAddrId: selectedBuyerBillAddrId,
                shipAddrId: selectedBuyerShipAddrId,
                pmBillAddrId: relatedSellerPOItems[0].bPOpmBillAddrId,
                GSTType: isIGST ? "I" : "CS", //GSTType: relatedBuyerPOmaxDateDocNoAndFileNo?.GSTType,
                logisticAmount: logisticAmount,
                logisticsHSNCode: logisticsHSNCode,
                logisticPartnerId: trackingDetails.logisticPartnerId,
                trackingNumber: trackingDetails.trackingNumber,
                trackingOrderLink: trackingDetails.trackingOrderLink,
                expectedDeliveryDate: trackingDetails.expectedDeliveryDate,
                userId: relatedBuyerPOmaxDateDocNoAndFileNo.userId,
                createdBy: userId,
                updatedBy: userId,
                buyerPONumbers: buyerPONumbers,
                buyerPODate: latestBuyerPODate,
                vehicleNo: vehicleNo ? vehicleNo : null,
                recipientUserId: recipientUser ? recipientUser?.userId : null,
                itemsGroupedBy: itemsGroupedBy,
                suppliedToExporter: suppliedToExporter,
                TCSRate: TCSRate
            }
            if(showBiofuelActivityType){
                newDispatchNote.biofuelActivityType = biofuelActivityType;
            }

            let gstChangedItems = []
            let invalidHSNCodes = []
            let gstNotMatchedHSNCodes = []
            let unVerifiedPIPunches = []
            let emptyPIPunchSellerPO = null
            let invalidPIPunchQty = null

            let newDispatchNoteItems = relatedSellerPOItems.map(eachSellerPOItem => {
                let relatedBuyerPOItem = selectedBuyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOId === eachSellerPOItem.buyerPOId && eachBuyerPOItem.buyerReqItemId === eachSellerPOItem.buyerReqItemId)

                if(!emptyPIPunchSellerPO && (!eachSellerPOItem.sellerPIPunchItemId || eachSellerPOItem.sellerPIPunchItemId?.length === 0)){
                    emptyPIPunchSellerPO = eachSellerPOItem
                }

                if (eachSellerPOItem?.invGSTRate != eachSellerPOItem?.bPOGSTRate) {
                    gstChangedItems.push(eachSellerPOItem)
                }
                const relatedHSNMasterCode = HSNMasterData.find(eachHSNDetail => eachHSNDetail.HSNCode === parseInt(eachSellerPOItem.invHSNCode))
                if (!relatedHSNMasterCode) {
                    invalidHSNCodes.push(eachSellerPOItem.invHSNCode)
                } else {
                    let relatedGSTRates = HSNMasterData?.filter(eachHSN => eachHSN?.HSNCode === parseInt(eachSellerPOItem.invHSNCode))

                    if (relatedGSTRates && relatedGSTRates.length > 0) {
                        let relatedReplaceItemGSTRate = relatedGSTRates.find(eachGSTRate => eachGSTRate.GSTRate === parseInt(eachSellerPOItem?.invGSTRate))
                        if (!relatedReplaceItemGSTRate) {
                            gstNotMatchedHSNCodes.push(eachSellerPOItem.invHSNCode)
                        }
                    }
                }

                if(eachSellerPOItem.sellerPIPunchItemId?.length && eachSellerPOItem.sellerPIPunchDetails?.length){
                    const relatedSellerPIPunches = eachSellerPOItem.sellerPIPunchDetails.filter(eachSellerPIPunchDetails => {
                        return eachSellerPOItem.sellerPIPunchItemId.includes(eachSellerPIPunchDetails.sellerPIPunchItemId) && !eachSellerPIPunchDetails.verifiedBy && !eachSellerPIPunchDetails.skippedBy
                    })
                    const sellerPIPunchNums = relatedSellerPIPunches.map(eachSelPIPunch => eachSelPIPunch.sellerPINumber)
                    unVerifiedPIPunches = [...unVerifiedPIPunches, ...sellerPIPunchNums]

                    const selectedSellerPIPunches = eachSellerPOItem.sellerPIPunchDetails.filter(eachSellerPIPunchDetails => eachSellerPOItem.sellerPIPunchItemId.includes(eachSellerPIPunchDetails.sellerPIPunchItemId))
                    if (selectedSellerPIPunches.length && !invalidPIPunchQty) {
                        const totalAvailableQty = selectedSellerPIPunches.reduce((sum, punch) => { return sum + (punch.availablePIPunchQty || 0) }, 0)
                        if (totalAvailableQty < eachSellerPOItem.dispatchQty) {
                            const selectedPIPunches = selectedSellerPIPunches.map(eachSelPIPunch => eachSelPIPunch.sellerPINumber)
                            invalidPIPunchQty = {
                                sellerPOItemId: eachSellerPOItem.sellerPOItemId,
                                selectedPIPunches: selectedPIPunches,
                                requiredDispatchQty: eachSellerPOItem.dispatchQty,
                                availableQty: totalAvailableQty,
                                materialId: eachSellerPOItem.materialId,
                                docNo: eachSellerPOItem.docNo
                            }
                        }
                    }
                }

                if(!newDispatchNote.multiPartyFlow && eachSellerPOItem.multiPartyFlow){
                    newDispatchNote.multiPartyFlow = eachSellerPOItem.multiPartyFlow
                }

                return {
                    productSpecification: eachSellerPOItem.productSpecification,
                    companyProdName: eachSellerPOItem.companyProdName,
                    companyProdSpec: eachSellerPOItem.companyProdSpec,
                    UOM: eachSellerPOItem.UOM,
                    buyerReqItemId: relatedBuyerPOItem.buyerReqItemId,
                    sellerPOId: eachSellerPOItem.sellerPOId,
                    sellerPOItemId: eachSellerPOItem.sellerPOItemId,
                    buyerReqId: relatedBuyerPOItem.buyerReqId,
                    buyerPOId: relatedBuyerPOItem.buyerPOId,
                    buyerPOItemId: relatedBuyerPOItem.buyerPOItemId,
                    materialId: eachSellerPOItem.materialId,
                    qty: eachSellerPOItem.dispatchQty,
                    listPrice: relatedBuyerPOItem?.bPOListPrice,
                    unitPrice: relatedBuyerPOItem?.bPOUnitPrice,
                    HSNCode: eachSellerPOItem?.invHSNCode,
                    GSTRate: eachSellerPOItem?.invGSTRate,
                    itemAmountBeforeTax: relatedBuyerPOItem?.bPOItemAmountBeforeTax,
                    itemAmountWithTax: relatedBuyerPOItem.bPOItemAmountWithTax,
                    buyerRateContractId: relatedBuyerPOItem?.buyerRateContractId,
                    createdBy: userId,
                    updatedBy: userId,
                    poScheduleItemId: eachSellerPOItem.poScheduleItemId,
                    sellerPIPunchItemId: eachSellerPOItem.sellerPIPunchItemId?.length > 0 ? eachSellerPOItem.sellerPIPunchItemId : null,
                    sellerPODocNo: eachSellerPOItem.docNo,
                    stockDoc: eachSellerPOItem.stockDoc
                }
            })

            if(emptyPIPunchSellerPO){
                return dispatch(raiseToast({ severity: 'error', detail: `Please select PI Punch for Material Id ${emptyPIPunchSellerPO.materialId} (${emptyPIPunchSellerPO.docNo})`, life: 3000 }))
            }

            unVerifiedPIPunches = _.uniqBy(unVerifiedPIPunches)
            
            if(unVerifiedPIPunches.length){
                return dispatch(raiseToast({ severity: 'error', detail: `PI- ${unVerifiedPIPunches.join(', ')} is/are not verified` }))
            }

            if(invalidPIPunchQty && invalidPIPunchQty.selectedPIPunches){
                return dispatch(raiseToast({ severity: 'error', detail: `Insufficient PI Punch quantity for PI \`${invalidPIPunchQty.selectedPIPunches.join(', ')}\` (Doc No: ${invalidPIPunchQty.docNo}, Material ID: ${invalidPIPunchQty.materialId}). Available quantity: ${invalidPIPunchQty.availableQty}. Please select valid punches!` }))
            }

            if (invalidHSNCodes.length) {
                return dispatch(raiseToast({ severity: 'error', detail: `HSN codes ${invalidHSNCodes.join(", ")} are invalid` }))
            }

            if (gstNotMatchedHSNCodes.length) {
                return dispatch(raiseToast({ severity: 'error', detail: `HSN codes ${gstNotMatchedHSNCodes.join(", ")} are not having selected GST rates`, life: 3000 }))
            }

            if (gstChangedItems.length > 0) {
                if (!window.confirm("The GST rate was modified by seller - please check")) {
                    return
                }
            }

            let calculatedDispatchNote = calculateDispatchNote(newDispatchNote, newDispatchNoteItems)
            newDispatchNote = { ...calculatedDispatchNote.dispatchNote, dispatchNoteItems: calculatedDispatchNote.dispatchNoteItems }
        }

        let relatedDispatchSellerPOIds = relatedSellerPOItems?.map(eachSellerPOItem => eachSellerPOItem.sellerPOId)
        let relatedDispatchSellerPOs = selectedDispatchSellerPOs?.filter(eachDispatchSellerPO => relatedDispatchSellerPOIds.includes(eachDispatchSellerPO.sellerPOId))
        let updateableBuyerPOsIds = selectedDispatchSellerPOs?.map(eachDispatchSellerPO => eachDispatchSellerPO.buyerPOId)
        let updateableBuyerQuotesIds = selectedDispatchSellerPOs?.map(eachDispatchSellerPO => eachDispatchSellerPO.bPObuyerQuoteId)
        let relatedDispatchSellerbPObillAddrIds = relatedDispatchSellerPOs?.map(eachDispatchSellerPO => eachDispatchSellerPO.bPObillAddrId)
        let relatedDispatchSellerbPOshipAddrIds = relatedDispatchSellerPOs?.map(eachDispatchSellerPO => eachDispatchSellerPO.bPObillAddrId)

        let isNewBillAddrIdSelected = !relatedDispatchSellerbPObillAddrIds.includes(newDispatchNote?.billAddrId)
        let isNewShipAddrIdSelected = !relatedDispatchSellerbPOshipAddrIds.includes(newDispatchNote?.shipAddrId)
        
        if (newDispatchNote) {
            setNewDispatchNote(newDispatchNote)

            let confirmMessage = 'Are you sure you want to continue...?'

            if(isLogisticsDeliveryAtActuals){
                if(!totalBuyerPOLogisticAmount && logisticAmount == 0){
                    return dispatch(raiseToast({ severity: 'warn', detail: `Logistics on Actual was selected. Please enter logistics amount atleast 1 rupee`, life: 3000 }))
                }else{
                    confirmMessage = "Logistics on Actual was selected, please ensure correct logistics are entered above.\n" + confirmMessage
                    if (logisticAmount < totalBuyerPOLogisticAmount) {
                        confirmMessage = "Entered logistics amount is lower than PO logistics amount. \n" + confirmMessage
                    }
                }
            }else{
                if (totalBuyerPOLogisticAmount > 0 && logisticAmount == 0) {
                    confirmMessage = "BuyerPO logistic was there, do you want to continue without logistics."
                }

                if (logisticAmount > totalBuyerPOLogisticAmount) {
                    return dispatch(raiseToast({ severity: 'warn', detail: `Logistic amount should not greater than ${totalBuyerPOLogisticAmount}`, life: 3000 }))
                }
            }

            if (isGenerateInvoice) {
                if (logisticAmount > 0 && !logisticsHSNCode) {
                    return dispatch(raiseToast({ severity: 'warn', detail: 'Please Enter logistics HSNCode', life: 3000 }))
                } else {
                    setIsConfirmReplaceDialogVisible(true)
                }
            }
            else {
                if (window.confirm(confirmMessage)) {
                    setIsLoading(true)
                    let addDispatchNotesResponse = await insertDispatchNote({ newDispatchNote, trackingDetails, isGenerateInvoice, isNewBillAddrIdSelected, isNewShipAddrIdSelected, buyerPOIds: updateableBuyerPOsIds, buyerQuoteIds: updateableBuyerQuotesIds })
                    console.log("addDispatchNotesResponse===", addDispatchNotesResponse)

                    if (addDispatchNotesResponse.failure) {
                        dispatch(raiseToast({ severity: 'error', summary: 'Dispatch Note not added', detail: addDispatchNotesResponse.data.error, life: 3000 }))
                    } else {
                        setSelectedDispatchSellerPOItems(null)
                        setSelectedDispatchSellerPOs([])
                        setIsCreateDispatchNoteVisible(false)
                        setIsCreateInvoiceModalVisible(false)
                        setNewDispatchNote([])
                        dispatch(raiseToast({ severity: 'success', detail: 'Dispatch Note added successfully', life: 3000 }))
                        dispatch(fetchSellerPOs({ ...searchParams, ...paginationParams }))

                        if (addDispatchNotesResponse.data?.buyerInvoice) {
                            window.open(`/buyerInvoice/${addDispatchNotesResponse.data?.buyerInvoice?.buyerInvoiceId}`, '_blank')
                        }

                        if (addDispatchNotesResponse.data?.deliveryChallan?.[0]?.deliveryChallanId) {
                            const docCopyRes = await getDocCopyByDocNo(addDispatchNotesResponse.data?.deliveryChallan?.[0]?.docNo, true)

                            if (docCopyRes?.failure) {
                                setIsLoading(false)
                                return dispatch(raiseToast({ severity: 'error', summary: "Delivery Challan Document", detail: docCopyRes.data.error, life: 3000 }))
                            }

                            if (!docCopyRes?.docLocation) {
                                setIsLoading(false)
                                return dispatch(raiseToast({ severity: 'error', summary: "Delivery Challan Document", detail: "Delivery Challan document was not found.", life: 3000 }))
                            }

                            downloadFile(docCopyRes.docLocation, 'deliveryChallan.pdf')
                        }

                    }

                    setIsLoading(false)
                }
            }
        }
    }

    const handleSubmitConvertToStock = async (sellerPOItems) => {
        if (window.confirm("Are you sure want to convert these materials back to smart stock?")) {
            setIsLoading(true)
            const updateRes = await convertToStockQty({ sellerPOItems: sellerPOItems })

            if (updateRes?.failure) {
                dispatch(raiseToast({ severity: 'warn', detail: updateRes?.data?.error, life: 3000 }))
            } else {
                dispatch(raiseToast({ severity: 'success', detail: "Convert to Stock done Successfully", life: 3000 }))
                setIsCovertToStockVisible(false)
                dispatch(fetchSellerPOs({ ...searchParams, ...paginationParams }))

            }
            setIsLoading(false)

        }
    }

    const handleSubmitCreateDispatchWithReplaceProducts = async (isGenerateInvoice, replacementItems) => {
        let dispatchSellerPOItemsArr = Object.values(selectedDispatchSellerPOItems).flat()
        const relatedSellerPOItems = dispatchSellerPOItemsArr.filter(eachSellerPOItem => eachSellerPOItem.dispatchQty > 0)
        let relatedDispatchSellerPOIds = relatedSellerPOItems?.map(eachSellerPOItem => eachSellerPOItem.sellerPOId)
        let relatedDispatchSellerPOs = selectedDispatchSellerPOs?.filter(eachDispatchSellerPO => relatedDispatchSellerPOIds.includes(eachDispatchSellerPO.sellerPOId))
        let updateableBuyerPOsIds = selectedDispatchSellerPOs?.map(eachDispatchSellerPO => eachDispatchSellerPO.buyerPOId)
        let updateableBuyerQuotesIds = selectedDispatchSellerPOs?.map(eachDispatchSellerPO => eachDispatchSellerPO.bPObuyerQuoteId)
        let relatedDispatchSellerbPObillAddrIds = relatedDispatchSellerPOs?.map(eachDispatchSellerPO => eachDispatchSellerPO.bPObillAddrId)
        let relatedDispatchSellerbPOshipAddrIds = relatedDispatchSellerPOs?.map(eachDispatchSellerPO => eachDispatchSellerPO.bPObillAddrId)

        let isNewBillAddrIdSelected = !relatedDispatchSellerbPObillAddrIds.includes(newDispatchNote?.billAddrId)
        let isNewShipAddrIdSelected = !relatedDispatchSellerbPOshipAddrIds.includes(newDispatchNote?.shipAddrId)
        if (newDispatchNote) {
            setIsLoading(true)
            let addDispatchNotesResponse = await insertDispatchNote({ newDispatchNote, isGenerateInvoice, replacementItems, isNewBillAddrIdSelected, isNewShipAddrIdSelected, buyerPOIds: updateableBuyerPOsIds, buyerQuoteIds: updateableBuyerQuotesIds })
            // console.log("addDispatchNotesResponse===", addDispatchNotesResponse)

            if (addDispatchNotesResponse.failure) {
                dispatch(raiseToast({ severity: 'error', detail: addDispatchNotesResponse.data.error, summary: 'Dispatch Note not added', life: 3000 }))
            } else {
                setSelectedDispatchSellerPOItems(null)
                setSelectedDispatchSellerPOs([])
                setIsCreateDispatchNoteVisible(false)
                setIsCreateInvoiceModalVisible(false)
                setNewDispatchNote(null)
                dispatch(raiseToast({ severity: 'success', detail: 'Dispatch Note and Invoice added successfully', life: 3000 }))

                if (addDispatchNotesResponse.data?.deliveryChallan?.[0]?.deliveryChallanId) {
                    const docCopyRes = await getDocCopyByDocNo(addDispatchNotesResponse.data?.deliveryChallan?.[0]?.docNo, true)
                    console.log("docCopy-Res", docCopyRes)

                    if (docCopyRes?.failure) {
                        setIsLoading(false)
                        return dispatch(raiseToast({ severity: 'error', summary: "Delivery Challan Document", detail: docCopyRes.data.error, life: 3000 }))
                    }

                    if (!docCopyRes?.docLocation) {
                        setIsLoading(false)
                        return dispatch(raiseToast({ severity: 'error', summary: "Delivery Challan Document", detail: "Delivery Challan document was not found.", life: 3000 }))
                    }

                    downloadFile(docCopyRes.docLocation, 'deliveryChallan.pdf')
                }

                if (addDispatchNotesResponse.data?.buyerInvoice?.buyerInvoiceId) {
                    window.open(`/buyerInvoice/${addDispatchNotesResponse.data?.buyerInvoice?.buyerInvoiceId}`, '_blank')
                }
            }

            setIsLoading(false)
        }
    }

    const handleReplacementItemsAcceptClick = () => {
        setIsCreateInvoiceModalVisible(true)
        setIsConfirmReplaceDialogVisible(false)
    }

    const handleReplacementItemsRejectClick = () => {
        setIsConfirmReplaceDialogVisible(false)
        handleSubmitCreateDispatchWithReplaceProducts(true)
    }

    const handleShippingAddress = (shipAddrId) => {
        if (shipAddrId) {
            setSelectedBuyerShipAddrId(shipAddrId)
        } else {
            setSelectedBuyerShipAddrId(null)
        }
    }

    const handleBillingAddress = (billAddrId) => {
        if (billAddrId) {
            setSelectedBuyerBillAddrId(billAddrId)
        } else {
            setSelectedBuyerBillAddrId(null)
        }
    }

    const handleSelectCheckbox = (event, row) => {
        let updated_products = []
        if (selectedDispatchSellerPOs.includes(row)) {
            updated_products = selectedDispatchSellerPOs.filter(dispatch => dispatch.sellerPOId === row.sellerPOId ? false : true)
        }
        else {
            updated_products = [...selectedDispatchSellerPOs, row]
        }
        setSelectedDispatchSellerPOs(updated_products)
    }

    const handleViewSchedule = async (buyerPOItemId) => {
        setIsScheduleHistoryVisible(true)
        setIsScheduleLoading(true)
        setSelectedPOItemForViewSchedule(buyerPOItemId)
        const poScheduleItemsRes = await getPOScheduleItemsByBuyerPOItemId(buyerPOItemId)
        if (poScheduleItemsRes?.failure) {

        } else {
            setPOScheduleItems(poScheduleItemsRes?.data)
        }
        setIsScheduleLoading(false)
    }

    const handleSearchTabDisplay = () => {
        if (!isSearchPinned) {
          dispatch(setIsSearchVisible(!isSearchVisible))
        }
    }

    const selectAllDispatchProducts = () => {

        let relatedBuyerCompanyId = sellerPOsData[0]?.bPOcompanyId
        let relatedDispatchBuyerPO = sellerPOsData.find(eachRow => eachRow.bPOcompanyId !== relatedBuyerCompanyId)
        if (relatedDispatchBuyerPO) {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Please select unique buyer company', life: 3000 }))
        }

        let updated_products = []
        if (selectedDispatchSellerPOs.length === sellerPOsData.length) {
            updated_products = []
            handleHeaderExpand()
        }
        else {
            updated_products = sellerPOsData.map(row => row)
            setExpandedSellerPORows(null)
        }
        setSelectedDispatchSellerPOs(updated_products)
    }

    const actionBodyTemplate = (row) => {
        return (
            <>
                <Button label='GRN' style={{ width: "60px", height: "30px" }} onClick={() => { setVisibleGRN(true); setSelectedSellerPOForGRN(row) }} />
            </>
        )
    }

    const getHeaderCheckbox = () => {

        return (
            <div className="">
                <CheckboxField onChange={(e) => selectAllDispatchProducts(e)} checked={sellerPOsData?.length && selectedDispatchSellerPOs?.length === sellerPOsData?.length} />
            </div>
        )
    }

    const getBodyCheckbox = (row) => {

        let buyerCompanyId = ''

        if (row.bPOcompanyId) {
            buyerCompanyId = row.bPOcompanyId
        }

        let isBuyerCompanySame = false
        if (selectedDispatchSellerPOs.length > 0) {
            let selectedBuyerCompanyId = selectedDispatchSellerPOs[0].bPOcompanyId

            if (buyerCompanyId === selectedBuyerCompanyId) {
                isBuyerCompanySame = false
            } else {
                isBuyerCompanySame = true
            }
        }

        return (
            <div className='flex justify-content-center'>
                <CheckboxField checked={selectedDispatchSellerPOs.includes(row)} onChange={(e) => handleSelectCheckbox(e, row)} disabled={isBuyerCompanySame} />
            </div>
        )
    }

    const getSellerPODocNoBody = (row) => {
        let dateString = getDateString(row.createdAt)
        let relatedIncoTerm = incoTerms.find(eachIncoTerm => eachIncoTerm.incoTermId === row.incoTermId)
        return (
            <div className="text-center">
                <div className='flex flex-row justify-content-center'>
                    <p className='doc-no' style={{ cursor: "pointer" }} onClick={() => window.open(`/sellerpo/${row.sellerPOId}`, '_blank')}>{row.docNo}</p>
                    <CopyToClipboard text={row?.docNo} />
                    <a style={{ cursor: "pointer" }} onClick={() => window.open(`/vendor_payment_summary/${row.sellerPOId}`, '_blank')} >
                        <img className="ml-1" src={VPRupeeImg} style={{ height: 15 }} />
                    </a>
                </div>
                <div className="date-string">
                    {dateString}
                    {relatedIncoTerm && (
                        <> (<span style={{ fontWeight: "bold" }}>{relatedIncoTerm.incoTermShortName}</span>)</>
                    )}
                </div>
            </div>
        )
    }

    const getMaterialIdBody = (row) => {
        const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === row.materialId)
        const relatedMaterialBrand = materialBrands?.find(eachMaterialBrand => eachMaterialBrand?.brandId === relatedMaterial?.brandId)

        return (
            <>
                <div className={`custom-tool-tip-${relatedMaterial?.materialId}`}>{row.materialId}</div>
                <Tooltip target={`.custom-tool-tip-${relatedMaterial?.materialId}`} position="top" autoHide={true}>
                    {getMaterialMasterDetailsTooltip({ brandName: relatedMaterialBrand?.brandName, productName: relatedMaterial?.productName, productSpecification: relatedMaterial?.productSpecification, variantName: relatedMaterial?.variantName, renderHTML: true, UOM: relatedMaterial?.UOM, UOMValue: relatedMaterial?.UOMValue })}
                </Tooltip>
            </>
        )
    }

    const getStatusBody = (row) => {
        let isGRNNotDone = true
        let isDispatchAwaiting = true
        let isDispatchFullyCompleted = true
        let imageUrl = ""
        let activeSellerPOItems = row?.sellerPOItems?.filter(eachSellerPOItem => eachSellerPOItem?.statusId === 3)
        if (activeSellerPOItems?.length > 0) {
            isGRNNotDone = activeSellerPOItems?.every(eachSellerPOItem => {
                const relatedSellerGRNQC = sellerGRNQCPunchAcceptedQtyItems?.find(eachSellerGRNQC => eachSellerGRNQC?.sellerPOItemId === eachSellerPOItem?.sellerPOItemId)
                return ((relatedSellerGRNQC?.totalAcceptedQuantity - relatedSellerGRNQC?.totalDispatchQty - relatedSellerGRNQC?.stockConvertedQty) === 0 && !relatedSellerGRNQC?.totalAcceptedQuantity) || !relatedSellerGRNQC
            })

            isDispatchAwaiting = activeSellerPOItems?.some(eachSellerPOItem => {
                const relatedSellerGRNQC = sellerGRNQCPunchAcceptedQtyItems?.find(eachSellerGRNQC => eachSellerGRNQC?.sellerPOItemId === eachSellerPOItem?.sellerPOItemId)
                return (relatedSellerGRNQC?.totalAcceptedQuantity - relatedSellerGRNQC?.totalDispatchQty - relatedSellerGRNQC?.stockConvertedQty) > 0
            })

            isDispatchFullyCompleted = activeSellerPOItems?.every(eachSellerPOItem => {
                const relatedSellerGRNQC = sellerGRNQCPunchAcceptedQtyItems?.find(eachSellerGRNQC => eachSellerGRNQC?.sellerPOItemId === eachSellerPOItem?.sellerPOItemId)
                return (relatedSellerGRNQC?.totalDispatchQty > 0 || relatedSellerGRNQC?.stockConvertedQty > 0) && relatedSellerGRNQC?.qty >= (parseFloat(relatedSellerGRNQC?.totalDispatchQty) + parseFloat(relatedSellerGRNQC?.stockAdjustedQty) + parseFloat(relatedSellerGRNQC?.stockConvertedQty))
            })

            if (isGRNNotDone) {
                imageUrl = MinusImg
            } else if (!isGRNNotDone && isDispatchAwaiting && !isDispatchFullyCompleted) {
                imageUrl = TruckAwaitingImg
            } else if (!isGRNNotDone && !isDispatchAwaiting && isDispatchFullyCompleted) {
                imageUrl = GreenCheckImg
            } else {
                imageUrl = WorkInProgressImg
            }
        }
        return (
            <div className="text-center">
                {
                    imageUrl === "" ? <div className="flex justify-content-center align-items-center"><Oval height={15} /></div> :
                        <img src={imageUrl} style={{ height: 25 }} />
                }
            </div>
        )
    }

    const getProductNameBody = (row) => {
        const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === row?.materialId)
        const relatedMaterialBrand = materialBrands?.find(eachMaterialBrand => eachMaterialBrand?.brandId === relatedMaterial?.brandId)
        return (
            <div>{relatedMaterialBrand?.brandName} - {relatedMaterial?.productName}{relatedMaterial?.variantName && ` - ${relatedMaterial?.variantName}`}</div>
        )
    }

    const getProductSpecBody = (row) => {
        const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === row?.materialId)
        return (
            <div>{relatedMaterial?.productSpecification} - {getUOMStr(relatedMaterial?.UOM, relatedMaterial?.UOMValue)}</div>
        )
    }

    const getQtyBody = (row) => {
        let relatedSellerGRNQCPunch = sellerGRNQCPunchAcceptedQtyItems?.find(eachSellerGRNQC => eachSellerGRNQC?.sellerPOItemId === row?.sellerPOItemId)
        return (
            <>
                <div className={`custom-tool-tip-${row?.sellerPOItemId}`}>
                    {row?.qty} - {row?.totalAcceptedQty} - {row?.totalDispatchedQty}
                </div>
                <Tooltip target={`.custom-tool-tip-${row?.sellerPOItemId}`} position="top" autoHide={true}>
                    <p className="m-0 mb-1">Rejected: {relatedSellerGRNQCPunch?.totalRejectedQuantity >= 0 ? relatedSellerGRNQCPunch?.totalRejectedQuantity : "-"}</p>
                    <p className="m-0">Short: {relatedSellerGRNQCPunch?.totalShortQuantity >= 0 ? relatedSellerGRNQCPunch?.totalShortQuantity : "-"}</p>
                    <p className="m-0">Converted: {relatedSellerGRNQCPunch?.stockConvertedQty >= 0 ? relatedSellerGRNQCPunch?.stockConvertedQty : "-"}</p>
                    <p className="m-0">CNDN: {relatedSellerGRNQCPunch?.stockCNDNQty >= 0 ? relatedSellerGRNQCPunch?.stockCNDNQty : "-"}</p>
                    <p className="m-0">Adjusted: {relatedSellerGRNQCPunch?.stockAdjustedQty >= 0 ? relatedSellerGRNQCPunch?.stockAdjustedQty : "-"}</p>
                </Tooltip>
            </>
        )
    }

    const getDeliveryDateBody = (row) => {
        const relatedPOPunchtems = poPunchItems?.filter(eachPOPunchItem => eachPOPunchItem?.buyerPOItemId === row?.buyerPOItemId)
        let getLatestPOPunch = sortArrayOfObjectsInAscendingDateOrder(relatedPOPunchtems, "expectedDeliveryDate")
        let deliveryDateStr = getDateString(getLatestPOPunch[getLatestPOPunch?.length - 1]?.expectedDeliveryDate)
        return (
            <>
                {
                    relatedPOPunchtems?.length === 0 ? <Button label="View Schedule" text className="small-btn" onClick={() => handleViewSchedule(row?.buyerPOItemId)} /> : (
                        deliveryDateStr
                    )
                }
            </>
        )
    }

    const handleSellerPOItemInputChange = (e, sellerPOId, sellerPOItemId) => {
        let updatedSellerPOsData = sellerPOsData.map(eachSellerPO => {
            if (eachSellerPO.sellerPOId === sellerPOId) {
                return {
                    ...eachSellerPO,
                    sellerPOItems: eachSellerPO.sellerPOItems.map(eachSellerPOItem =>
                        eachSellerPOItem.sellerPOItemId === sellerPOItemId
                            ? { ...eachSellerPOItem, [e.target.name]: e.target.value }
                            : eachSellerPOItem
                    )
                }
            }
            return eachSellerPO
        })

        dispatch(updateDispatchSPOsData(updatedSellerPOsData))
    }


    const handleEditClientExpectedDeliveryDate = (e, sellerPOId, sellerPOItemId) => {
        let updatedSellerPOsData = sellerPOsData.map(eachSellerPO => {
            if (eachSellerPO.sellerPOId === sellerPOId) {
                return {
                    ...eachSellerPO,
                    sellerPOItems: eachSellerPO.sellerPOItems.map(eachSellerPOItem =>
                        eachSellerPOItem.sellerPOItemId === sellerPOItemId
                            ? { ...eachSellerPOItem, isEditClientExpDelDate: true }
                            : eachSellerPOItem
                    )
                }
            }
            return eachSellerPO
        })
        dispatch(updateDispatchSPOsData(updatedSellerPOsData))
    }

    const handleSaveClientExpectedDeliveryDate = async (selectedSPOItem) => {

        if (!selectedSPOItem.updatedClientExpDelDate) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please selecte date", life: 3000 }))
        }

        let updatedData = {
            expectedClientDeliveryDate: selectedSPOItem.updatedClientExpDelDate,
            expectedClientDeliveryDateStatus: 1
        }

        if (window.confirm("Do you want update...?")) {
            setIsLoading(true)
            let updateSellerPOItemResponse = await updateSellerPOItem(selectedSPOItem.sellerPOItemId, updatedData)
            console.log("updateSellerPOItem-Response", updateSellerPOItemResponse)
            setIsLoading(false)
            if (updateSellerPOItemResponse.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: updateSellerPOItemResponse.data.error, life: 3000 }))
            } else {
                let updatedSellerPOsData = sellerPOsData.map(eachSellerPO => {
                    if (eachSellerPO.sellerPOId === selectedSPOItem.sellerPOId) {
                        return {
                            ...eachSellerPO,
                            sellerPOItems: eachSellerPO.sellerPOItems.map(eachSellerPOItem =>
                                eachSellerPOItem.sellerPOItemId === selectedSPOItem.sellerPOItemId
                                    ? { ...eachSellerPOItem, ...updatedData, updatedClientExpDelDate: null, isEditClientExpDelDate: false }
                                    : eachSellerPOItem
                            )
                        }
                    }
                    return eachSellerPO
                })

                dispatch(updateDispatchSPOsData(updatedSellerPOsData))

                return dispatch(raiseToast({ severity: 'success', detail: "Client expedted delivery date updated successfully", life: 3000 }))

            }
        }
    }

    const getBuyerDeliveryDateBody = (row) => {
        const relatedPOPunchtems = poPunchItems?.filter(eachPOPunchItem => eachPOPunchItem?.buyerPOItemId === row?.buyerPOItemId)
        let getLatestPOPunch = sortArrayOfObjectsInAscendingDateOrder(relatedPOPunchtems, "expectedDeliveryDate")
        let deliveryDateStr = getDateString(getLatestPOPunch[getLatestPOPunch?.length - 1]?.expectedDeliveryDate)

        let relatedBuyerDelDate = null
        if (row.expectedClientDeliveryDate) {
            relatedBuyerDelDate = new Date(row.expectedClientDeliveryDate)
        }

        return (
            <>
                {
                    relatedPOPunchtems?.length === 0 ?
                        <Button label="View Schedule" text className="small-btn" onClick={() => handleViewSchedule(row?.buyerPOItemId)} />
                        :
                        <>
                            <div className={`custom-tool-tip-buyer-deliveryDate-${row.sellerPOItemId}`} style={{ color: !row.expectedClientDeliveryDateStatus ? 'red' : null }}>
                                {
                                    row.isEditClientExpDelDate ?
                                        <div className="flex flex-column">
                                            <div className="flex flex-row mb-1">
                                                <CalendarField
                                                    name="updatedClientExpDelDate"
                                                    labelText=""
                                                    value={row?.updatedClientExpDelDate}
                                                    minDate={new Date()}
                                                    onChange={(e) => handleSellerPOItemInputChange(e, row.sellerPOId, row.sellerPOItemId)}
                                                    dateFormat='dd.mm.yy'
                                                />
                                                <i
                                                    style={{ fontSize: '0.8rem' , marginLeft: "5px" , marginTop: "15px"}}
                                                    onClick={() => handleSaveClientExpectedDeliveryDate(row)}
                                                    className={`pi pi-save cursor-pointer`}
                                                ></i>
                                            </div>
                                            <div className="mr-3">
                                                {relatedBuyerDelDate ? getDateString(relatedBuyerDelDate) : "-"}
                                            </div>
                                        </div>
                                        :
                                        <>
                                            {relatedBuyerDelDate ? getDateString(relatedBuyerDelDate) : "-"}
                                            {row.totalDispatchedQty !== row.qty && <i className="pi pi-pencil ml-1" onClick={(event) => handleEditClientExpectedDeliveryDate(event, row.sellerPOId, row.sellerPOItemId, "updatedClientExpDelDate")} style={{ fontSize: '0.6rem', cursor: "pointer" }}></i>}
                                        </>
                                }
                            </div>
                            <Tooltip target={`.custom-tool-tip-buyer-deliveryDate-${row.sellerPOItemId}`} position="top" autoHide >
                                <p className='m-0'> <b>Original Buyer Del. Date:</b> {deliveryDateStr ? deliveryDateStr : "-"}</p>
                            </Tooltip>
                        </>
                }
            </>
        )
    }

    const getPMDeliveryDateBody = (row) => {
        let relatedPMDeliveryDate = null
        if (row.updatedPMDeliveryDate) {
            relatedPMDeliveryDate = new Date(row.updatedPMDeliveryDate)
        }

        let origExpectedPMDeliveryDate = null
        if (row.updatedPMDeliveryDate) {
            origExpectedPMDeliveryDate = new Date(row.origExpectedPMDeliveryDate)
        }

        return (
            <>
                <div className={`custom-tool-tip-seller-deliveryDate-${row.sellerPOItemId}`}>
                    {relatedPMDeliveryDate ? getDateString(relatedPMDeliveryDate) : "-"}
                </div>
                <Tooltip target={`.custom-tool-tip-seller-deliveryDate-${row.sellerPOItemId}`} position="top" autoHide >
                    <p className='m-0'> <b>Original PM Del. Date:</b> {origExpectedPMDeliveryDate ? getDateString(origExpectedPMDeliveryDate) : "-"}</p>
                </Tooltip>
            </>
        )
    }

    const getFollowUpStatusandRemarks = (row) => {
        let relatedFollowUpStatus = followUpStatus.find(eachFollowup => eachFollowup.followUpStatusId === row.followUpStatusId)

        let remarkId = ""
        if (row.remarks) {
            remarkId = row.remarks.replace(/[\s./]+/g, '-').replace(/[^a-zA-Z0-9\-_]/g, '').toLowerCase()
        }
        
        return (
            <div>
                <div className='m-0' style={{ fontSize: "12px" }}>
                    <span style={{ display: '-webkit-box', WebkitBoxOrient: 'vertical', overflow: 'hidden', WebkitLineClamp: 1, lineHeight: '1.5em'}}  className={`custom-tool-tip-${remarkId}`}>{row.remarks}</span> 
                </div>
                {
                    row.followUpStatusId ? 
                    <div className='m-0' style={{ fontSize: "12px" }}>
                    {`(`}
                    <span style={{ fontWeight: "bold" }}>{relatedFollowUpStatus?.followUpStatusName}</span>
                    {`)`}
                </div> : null
                }
                { row.remarks ? 
                    <Tooltip target={`.custom-tool-tip-${remarkId}`} position="top" autoHide={true}>
                        <p className="m-0">{row.remarks}</p>
                    </Tooltip> 
                    : null
                }
            </div>
        )
    }

    const handleHeaderExpand = () => {
        let totalExpandedRows = 0
        sellerPOsData?.map(eachSellerPO => {
            let relatedDispatch = expandedSellerPORows?.[`${eachSellerPO.sellerPOId}`]
            if (relatedDispatch) {
                totalExpandedRows += 1
            }

        })
        if (totalExpandedRows === 0) {
            let expandedRows = {};

            sellerPOsData.forEach((row) => {
                let relatedRow = expandedSellerPORows?.[`${row?.sellerPOId}`]
                if (!relatedRow) {
                    expandedRows[`${row.sellerPOId}`] = true
                } else {
                    expandedRows = null
                }
            })
            setExpandedSellerPORows(expandedRows)
        } else {
            setExpandedSellerPORows(null)
        }
    }

    const handleCopyEmailClick = (emailId) => {
        if (emailId) {
            navigator.clipboard.writeText(emailId)
                .then(() => {
                    return dispatch(raiseToast({ severity: 'success', detail: "E-Mail Id Copied!", life: 3000 }))
                })
                .catch((error) => {
                    return dispatch(raiseToast({ severity: 'error', detail: "Can't copy E-Mail Id", life: 3000 }))
                })
        }
    }

    const header = () => {
        let totalExpandedRows = 0
        sellerPOsData?.map(eachDispatch => {
            let relatedDispatch = expandedSellerPORows?.[`${eachDispatch?.sellerPOId}`]
            if (relatedDispatch) {
                totalExpandedRows += 1
            }

        })

        return (
            <Button icon={totalExpandedRows > 0 ? "pi pi-angle-down" : "pi pi-angle-right"} text style={{ color: "grey", fontSize: "80" }} onClick={() => handleHeaderExpand()} />
        )
    }

    const handleSmartSearch = () => {
        dispatch(fetchSellerPOs({ 
            ...paginationParams, 
            dataType: searchParams.dataType, 
            orderTypeIds: [1, 2], 
            pageNo: 0, 
            isSmartSearch: true 
        }))
        dispatch(updateIsSmartSearch(true))
        setIsInitialSellerPOsData(false)
    }

    const smartSearchFilterBody = () => {
        return (
            <>
                <div className="custom-tooltip-smart-search" >
                    <img src={SmartSearchImg} style={{ height: 25, cursor: "pointer" }} onClick={handleSmartSearch} />
                </div>
                <Tooltip target=".custom-tooltip-smart-search" position="top" autoHide>
                    <p className="m-0 mb-1">Smart Search</p>
                </Tooltip>
            </>
        )
    }

    const rowExpansionTemplate = (data) => {
        let updatedSellerPOItems = data?.sellerPOItems?.map(eachSellerPOItem => {
            const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachSellerPOItem?.materialId)
            const relatedSellerGRNQCPunch = sellerGRNQCPunchAcceptedQtyItems?.find(eachSellerGRNQC => eachSellerGRNQC?.sellerPOItemId === eachSellerPOItem?.sellerPOItemId)
            const relatedBuyerPOItem = buyerPOItems?.find(eachBuyerPOItem => eachBuyerPOItem?.buyerPOItemId === eachSellerPOItem?.buyerPOItemId)
            return {
                ...eachSellerPOItem,
                ...relatedMaterial,
                unitPrice: `${currencyShortName}. ${eachSellerPOItem?.unitPrice}`,
                totalAcceptedQty: relatedSellerGRNQCPunch?.totalAcceptedQuantity ? relatedSellerGRNQCPunch?.totalAcceptedQuantity : "0",
                totalDispatchedQty: relatedSellerGRNQCPunch?.totalDispatchQty ? relatedSellerGRNQCPunch?.totalDispatchQty : "0",
                bPOUnitPrice: relatedBuyerPOItem?.bPOUnitPrice
            }
        })
        updatedSellerPOItems = updatedSellerPOItems?.filter(eachSellerPOItem => eachSellerPOItem?.statusId === 3)
        const getBuyerUnitPrice = (row) => {
            return numberConversion(row.bPOUnitPrice, numberLocale)
        }

        return (
            <div className="p-2 ml-8">
                <div className="expanded-table p-0 flex flex-row p-card mb-0" style={{ width: "100%" }} >
                    <div style={{ width: "0.4%", backgroundColor: "#ced4da" }}></div>
                    <div className='' style={{ width: "99.6%" }}>
                        <DataTable value={updatedSellerPOItems}>
                            <Column header="Material Id" className={`custom-tool-tip-${"materialId"}`} body={getMaterialIdBody} style={{ width: "10%" }}></Column>
                            <Column field="" header="Product Name" body={getProductNameBody} style={{ width: "15%" }} ></Column>
                            <Column field="productSpecification" header="Product Specification" body={getProductSpecBody} style={{ width: "35%" }} ></Column>
                            <Column field="bPOUnitPrice" header="Unit Price" body={getBuyerUnitPrice} style={{ width: "7%" }}></Column>
                            <Column field="" header="PO-Acc-DP Qty" headerTooltip="Doc Qty - Accepted - Dispatched" headerTooltipOptions={{ position: "top", autoHide: true }} body={getQtyBody} style={{ width: "10%" }} ></Column>
                            {/* <Column field="" header="Delivery Due" body={getDeliveryDateBody} style={{width : "10%"}}></Column> */}
                            <Column field="" header="Buyer Expt Del. Date" body={getBuyerDeliveryDateBody} style={{ width: "13%" }}></Column>
                            <Column field="" header="PM Del. Date" body={getPMDeliveryDateBody} style={{ width: "10%" }}></Column>
                            <Column field="" header="Followup Status" body={getFollowUpStatusandRemarks} style={{ width: "10%" }}></Column>
                        </DataTable>
                    </div>
                </div>
            </div>
        );

    }

    const rowClassName = (data) => {
        if (isSmartSearch) {
            let allGreen = data.sellerPOItems?.every(item => [2, 3, 8].includes(item.followUpStatusId)) 
            let hasYellow = data.sellerPOItems?.some(item => !item.expectedClientDeliveryDateStatus)
            return allGreen ? "follow-up-row-bg2" : hasYellow ? "follow-up-row-bg" : ""
        }
    
        return ""
    }

    const allowExpansion = (rowData) => {
        return rowData?.sellerPOItems?.length > 0;
    }

    const handlePageChange = async (e) => {
        let sellerPOParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            createdAt: 'ASC'
        }

        if(isSmartSearch){
            sellerPOParams.isSmartSearch = isSmartSearch
            sellerPOParams.dataType = searchParams.dataType
        }else{
            sellerPOParams = { ...searchParams, ...sellerPOParams}
            if (sellerPOParams.searchBy !== "all") {
                sellerPOParams[sellerPOParams.searchBy] = sellerPOParams.searchText.trim()
            }
        }
        
        dispatch(fetchSellerPOs({ ...sellerPOParams }))
        setSelectedDispatchSellerPOs([])
        setSelectedDispatchSellerPOItems([])
        setIsCreateDispatchNoteVisible(false)
        setIsInitialSellerPOsData(false)
    }

    const getSellerCompanyName = (row) => {
        let mobileNumber = row.sellerPhoneNumber
        mobileNumber = getMobileNumber(mobileNumber)

        return (
            <>
                <div className={`custom-tool-tip-${row.userId} text-center`}>
                    <div className='flex flex-column justify-content-center'>
                        <div> {getFullName(row.sellerFirstName, row.LastName)}</div>
                        <div className='m-0' style={{ fontSize: "12px" }}>
                            {`(`}
                            <span style={{ fontWeight: "bold" }}>{getCompanyShortName(row.sellerCompanyName)}</span>
                            {`)`}
                        </div>
                    </div>
                    <div className="flex flex-row justify-content-center">
                        <div style={{ cursor: "pointer", marginRight: '20px' }} className={`custom-tool-tip-${row.userId}`}><i className="pi pi-envelope pl-1 doc-copy-icon" style={{ cursor: "pointer", color: "#000000a8" }} onClick={() => handleCopyEmailClick(row.sellerEmailId)} ></i></div>
                        <div className={`custom-tool-tip-${mobileNumber}`} style={{ cursor: 'pointer' }} onClick={() => window.open(`https://wa.me/${mobileNumber}`)}>{row.sellerPhoneNumber && <i className="pi pi-whatsapp pl-1 doc-copy-icon" style={{ color: "#000000a8"}}></i>}</div>
                    </div>
                </div>
                <Tooltip target={`.custom-tool-tip-${mobileNumber}`} position="top" autoHide={true}>
                    <p className="m-0">{row.sellerPhoneNumber}</p>
                </Tooltip>
                <Tooltip target={`.custom-tool-tip-${row.userId}`} position="top" autoHide={true}>
                    <p className="m-0">{row.sellerEmailId}</p>
                </Tooltip>
            </>
        )
    }

    const getbPOdocNoBody = (row) => {
        if (row.bPOdocNo) {
            let dateString = getDateString(row.bPOcreatedAt)
            let buyerName = getFullName(row.buyerFirstName, row.buyerLastName)
            const updatedRowData = { ...row, orderTypeId: row.buyerReqOrderTypeId }
            const { shortDenotation, fullDenotation } = getReqShortDetails(updatedRowData, orderTypes)
            return (
                <div className="text-center">
                    <div className={`flex flex-row justify-content-center custom-tooltip-${row.buyerPOId}`}>
                        <p className='doc-no' style={{ cursor: "pointer" }} onClick={() => window.open(`/buyerpo/${row.buyerPOId}`, '_blank')}>{row.bPOdocNo}</p>
                        <CopyToClipboard text={row.bPOdocNo} />
                    </div>
                    <Tooltip target={`.custom-tooltip-${row.buyerPOId}`} position="top" autoHide>
                        <>
                            <p className="m-0 mb-1">Req No. {row.buyerReqDocNo}</p>
                            <p className="m-0">Client PO Num : {row.bPOclientPONum}</p>
                        </>
                    </Tooltip>
                    <div className="date-string">{buyerName}</div>
                    <div className="date-string">{dateString}</div>
                    <p className={`date requirement-short-details-${row.buyerPOId}`}>{shortDenotation}</p>
                    <Tooltip target={`.requirement-short-details-${row.buyerPOId}`} position='bottom'>
                        <span>{fullDenotation}</span>
                    </Tooltip>
                </div>
            )
        }
    }

    const getKAMNameAndCityBody = (row) => {
        let kamName = getFullName(row.kamFirstName, row.kamLastName)

        let relatedPMBranch = companyBranches?.find(eachPMBranch => eachPMBranch?.branchId === row.pmBranchId)
        if (kamName) {
            return (
                <div>
                    <PMUserName userName={kamName} userId={row.createdBy}/>
                    <div className='m-0' style={{ fontSize: "12px" }}>
                        {`(`}
                        <span style={{ fontWeight: "bold" }}>{relatedPMBranch?.branchName}</span>
                        {`)`}
                    </div>
                </div>
            )
        }
    }

    const getGRNDateBody = (row) => {
        const relatedGRNQCPunch = sellerGRNQCPunches?.find(eachSellerGRNQCPunch => eachSellerGRNQCPunch?.sellerPOId == row.sellerPOId)
        return (
            <>
                <div>
                    {relatedGRNQCPunch?.sellerPOId ? getDateString(relatedGRNQCPunch?.processedDate) : "-"}
                </div>
            </>
        )
    }

    const handleSubmitCreateDispatchWithRenamedInvoiceItems = async (isGenerateInvoice, renamedItems) => {
        let dispatchSellerPOItemsArr = Object.values(selectedDispatchSellerPOItems).flat()
        const relatedSellerPOItems = dispatchSellerPOItemsArr.filter(eachSellerPOItem => eachSellerPOItem.dispatchQty > 0)
        let relatedDispatchSellerPOIds = relatedSellerPOItems.map(eachSellerPOItem => eachSellerPOItem.sellerPOId)
        let relatedDispatchSellerPOs = selectedDispatchSellerPOs.filter(eachDispatchSellerPO => relatedDispatchSellerPOIds.includes(eachDispatchSellerPO.sellerPOId))
        let updateableBuyerPOsIds = selectedDispatchSellerPOs.map(eachDispatchSellerPO => eachDispatchSellerPO.buyerPOId)
        let updateableBuyerQuotesIds = selectedDispatchSellerPOs.map(eachDispatchSellerPO => eachDispatchSellerPO.bPObuyerQuoteId)
        let relatedDispatchSellerbPObillAddrIds = relatedDispatchSellerPOs.map(eachDispatchSellerPO => eachDispatchSellerPO.bPObillAddrId)
        let relatedDispatchSellerbPOshipAddrIds = relatedDispatchSellerPOs.map(eachDispatchSellerPO => eachDispatchSellerPO.bPObillAddrId)

        let isNewBillAddrIdSelected = !relatedDispatchSellerbPObillAddrIds.includes(newDispatchNote?.billAddrId)
        let isNewShipAddrIdSelected = !relatedDispatchSellerbPOshipAddrIds.includes(newDispatchNote?.shipAddrId)
        if (newDispatchNote) {
            setIsLoading(true)
            let addDispatchNotesResponse = await insertDispatchNote({ newDispatchNote, isGenerateInvoice, isNewBillAddrIdSelected, isNewShipAddrIdSelected, buyerPOIds: updateableBuyerPOsIds, buyerQuoteIds: updateableBuyerQuotesIds, renamedItems })

            if (addDispatchNotesResponse.failure) {
                dispatch(raiseToast({ severity: 'error', detail: addDispatchNotesResponse.data.error, summary: 'Dispatch Note not added', life: 3000 }))
            } else {
                setSelectedDispatchSellerPOItems(null)
                setSelectedDispatchSellerPOs([])
                setIsCreateDispatchNoteVisible(false)
                setIsConfirmReplaceDialogVisible(false)
                setIsCreateInvoiceModalVisible(false)
                setVisibleRenameBuyerInvoiceItems(false)
                setNewDispatchNote(null)
                dispatch(raiseToast({ severity: 'success', detail: 'Dispatch Note and Invoice added successfully', life: 3000 }))

                if (addDispatchNotesResponse.data?.deliveryChallan?.[0]?.deliveryChallanId) {
                    const docCopyRes = await getDocCopyByDocNo(addDispatchNotesResponse.data?.deliveryChallan?.[0]?.docNo, true)
                    console.log("docCopy-Res", docCopyRes)

                    if (docCopyRes?.failure) {
                        setIsLoading(false)
                        return dispatch(raiseToast({ severity: 'error', summary: "Delivery Challan Document", detail: docCopyRes.data.error, life: 3000 }))
                    }

                    if (!docCopyRes?.docLocation) {
                        setIsLoading(false)
                        return dispatch(raiseToast({ severity: 'error', summary: "Delivery Challan Document", detail: "Delivery Challan document was not found.", life: 3000 }))
                    }

                    downloadFile(docCopyRes.docLocation, 'deliveryChallan.pdf')
                }

                if (addDispatchNotesResponse.data?.buyerInvoice?.buyerInvoiceId) {
                    window.open(`/buyerInvoice/${addDispatchNotesResponse.data?.buyerInvoice?.buyerInvoiceId}`, '_blank')
                }
            }

            setIsLoading(false)
        }
    }

    const handleOnClickRenameProducts = () => {
        let dispatchNoteItems = []
        if (newDispatchNote.itemsGroupedBy === "buyerPOItemId") {
            let buyerPOItemsWiseDispatchNoteItems = {}
            newDispatchNote.dispatchNoteItems?.map(eachDispatchNoteItem => {
                dispatchNoteItems.push(eachDispatchNoteItem)
                if (!buyerPOItemsWiseDispatchNoteItems[eachDispatchNoteItem.buyerPOItemId]) {
                    buyerPOItemsWiseDispatchNoteItems[eachDispatchNoteItem.buyerPOItemId] = [];
                }

                buyerPOItemsWiseDispatchNoteItems[eachDispatchNoteItem.buyerPOItemId].push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))

            })

            dispatchNoteItems.map(eachDispatchNoteItem => {
                let relatedBuyerPODispatchNoteItem = buyerPOItemWiseDispatchNoteItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachDispatchNoteItem.buyerPOItemId)
                if (!relatedBuyerPODispatchNoteItem) {
                    eachDispatchNoteItem.totalQty = parseFloat(eachDispatchNoteItem.qty)
                    eachDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.totalQty * eachDispatchNoteItem.unitPrice, DECIMAL_LIMIT)
                    buyerPOItemWiseDispatchNoteItems.push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))
                } else {
                    relatedBuyerPODispatchNoteItem.qty = parseFloat(relatedBuyerPODispatchNoteItem.qty) + parseFloat(eachDispatchNoteItem.qty)
                    relatedBuyerPODispatchNoteItem.totalQty = parseFloat(relatedBuyerPODispatchNoteItem.totalQty) + parseFloat(eachDispatchNoteItem.qty)
                    relatedBuyerPODispatchNoteItem.totalAmount = round(relatedBuyerPODispatchNoteItem.qty * eachDispatchNoteItem.unitPrice, DECIMAL_LIMIT)
                }
            })

            setBuyerPOItemWiseDispatchNoteItems([...buyerPOItemWiseDispatchNoteItems])
        } else {
            let buyerReqItemWiseDispatchNoteItems = {}
            newDispatchNote.dispatchNoteItems?.map(eachDispatchNoteItem => {
                dispatchNoteItems.push(eachDispatchNoteItem)
                if (!buyerReqItemWiseDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId]) {
                    buyerReqItemWiseDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId] = [];
                }

                buyerReqItemWiseDispatchNoteItems[eachDispatchNoteItem.buyerReqItemId].push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))

            })

            dispatchNoteItems.map(eachDispatchNoteItem => {
                let relatedBuyerReqDispatchNoteItem = buyerReqWiseDispatchNoteItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachDispatchNoteItem.buyerReqItemId)
                if (!relatedBuyerReqDispatchNoteItem) {
                    eachDispatchNoteItem.totalQty = parseFloat(eachDispatchNoteItem.qty)
                    eachDispatchNoteItem.totalAmount = round(eachDispatchNoteItem.totalQty * eachDispatchNoteItem.unitPrice, DECIMAL_LIMIT)
                    buyerReqWiseDispatchNoteItems.push(JSON.parse(JSON.stringify(eachDispatchNoteItem)))
                } else {
                    relatedBuyerReqDispatchNoteItem.qty = parseFloat(relatedBuyerReqDispatchNoteItem.qty) + parseFloat(eachDispatchNoteItem.qty)
                    relatedBuyerReqDispatchNoteItem.totalQty = parseFloat(relatedBuyerReqDispatchNoteItem.totalQty) + parseFloat(eachDispatchNoteItem.qty)
                    relatedBuyerReqDispatchNoteItem.totalAmount = round(relatedBuyerReqDispatchNoteItem.qty * eachDispatchNoteItem.unitPrice, DECIMAL_LIMIT)
                }
            })

            setBuyerReqWiseDispatchNoteItems([...buyerReqWiseDispatchNoteItems])
        }

        setVisibleRenameBuyerInvoiceItems(true)
    }

    let relatedBuyerPOItemForViewSchedule = buyerPOItems?.find(eachBuyerPOItem => eachBuyerPOItem?.buyerPOItemId === selectedPOItemForViewSchedule)
    let viewScheduleMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === relatedBuyerPOItemForViewSchedule?.materialId)
    let materialStr = ""
    if (viewScheduleMaterial?.materialId) {
        materialStr = getMaterialMasterDetailsTooltip(viewScheduleMaterial)
    }

    const buyerInvoiceIdLinks = previewBuyerInvoicesIds.map((buyerPOId, index) => (
        <a
            key={index}
            href={`/buyerInvoice/${buyerPOId}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            {index !== 0 && ", "}
            {buyerPOId}
        </a>
    ))

    const message = (
        <p>
            Please cancel before proceeding.
            <br />
            Link: {buyerInvoiceIdLinks}
            <br />
            Please refresh after cancellation.
        </p>
    )

    const footer = (
        <div style={{ display: 'none' }}></div>
    )
    
    const actionButtons = [
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
        {
            icon: isSearchPinned ? "pi pi-lock" : "pi pi-lock-open",
            command: () => toggleSearchPin() 
        }
    ]
    
    let displaySearchBox = isSearchPinned || isHoveringSearchZone || isSearchVisible
    
    return (
        <div className="dispatch-layout flex flex-column">
            <div
                onMouseEnter={() => {
                    if (!isSearchPinned) {
                        setIsHoveringSearchZone(true)
                        setHasEverHoveredRightEdge(true)
                        dispatch(setIsSearchVisible(true))
                    }
                }}
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: '8px',
                    height: '100vh',
                    zIndex: 999
                }}
            />
            <div className="warehouse-top-container" style={{ width: "100%" }}>
                <h4 className="my-2" style={{ minWidth: "10%" }}>DISPATCH</h4>
                <div className="warehouse-display-container">
                    <DispatchDetailsDisplay 
                        warehouseStatus={warehouseStatus}
                        currentWarehouse={currentWarehouse}
                        selectedWarehouse={selectedWarehouse}
                        userRelatedWarehouses={userRelatedWarehouses}
                        getWarehouseStatusDetails={getWarehouseStatusDetails}
                        handleWarehouseInputChange={handleWarehouseInputChange}
                        isWarehouseEditable={isWarehouseEditable}
                        setIsWarehouseEditable={setIsWarehouseEditable}
                    />
                </div>
                <div className="flex gap-2 justify-content-end mb-2 ml-1 warehouse-button-container">
                    {/* <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                    <Button icon="pi pi-filter" className={`h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${!isSearchVisible ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                    <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <div className='flex flex-row'>
                <div className="dispatch-table followup-table" style={{ order: "1", width: displaySearchBox && !isMobileDevice ? "82%" : "100%" , maxHeight: "'calc(100%-100px)'"}}>
                    <div className='p-card mb-0' >
                        <div className="flex-grow-1" >
                            <DataTable
                                value={sellerPOsData}
                                expandedRows={expandedSellerPORows}
                                onRowToggle={(e) => setExpandedSellerPORows(e.data)}
                                rowExpansionTemplate={rowExpansionTemplate}
                                lazy
                                paginator
                                totalRecords={paginationParams?.totalRecords}
                                rows={paginationParams?.recordsPerPage}
                                page={paginationParams.pageNo}
                                onPage={e => handlePageChange(e)}
                                rowsPerPageOptions={[10, 20, 50, 100]}
                                first={paginationParams.pageNo * paginationParams.recordsPerPage}
                                scrollable
                                scrollHeight="520px"
                                loading={isPageLoading}
                                dataKey="sellerPOId"
                                rowClassName={rowClassName}
                            >
                                <Column field="" header={smartSearchFilterBody} style={{ width: '1rem' }} />
                                <Column expander={allowExpansion} header={header} style={{ width: '1rem' }} />
                                <Column field="" header={getHeaderCheckbox} body={getBodyCheckbox} />
                                <Column field="" header="Seller PO" body={getSellerPODocNoBody}></Column>
                                <Column field="" header="Seller Name" body={getSellerCompanyName}></Column>
                                <Column field="" header="KAM" body={getKAMNameAndCityBody}></Column>
                                <Column field="" header="Buyer PO" body={getbPOdocNoBody}></Column>
                                <Column body={actionBodyTemplate} header="GRN"></Column>
                                <Column field="" header="GRN Date" body={getGRNDateBody}></Column>
                                <Column header="Status" body={getStatusBody}></Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
                {displaySearchBox && (
                    <div
                        style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end"
                        onMouseLeave={(e) => {
                            const bounds = e.currentTarget.getBoundingClientRect()
                            const leftExit = e.clientX < bounds.left
                            const topExit = e.clientY < bounds.top
                            const bottomExit = e.clientY > bounds.bottom

                            if (!isSearchPinned && (leftExit || topExit || bottomExit)) {
                                setIsHoveringSearchZone(false)
                                setHasEverHoveredRightEdge(false)
                            }
                        }}

                        onMouseEnter={() => {
                            if (!isSearchPinned) {
                                setIsHoveringSearchZone(true)
                            }
                        }}
                    >
                        <Search
                            dataType={dataType}
                            setDataType={setDataType}
                            setSelectedDispatchSellerPOs={setSelectedDispatchSellerPOs}
                            setIsInitialSellerPOsData={setIsInitialSellerPOsData}
                        />
                    </div>
                )}
                {/* {isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Search
                            dataType={dataType}
                            setDataType={setDataType}
                            setSelectedDispatchSellerPOs={setSelectedDispatchSellerPOs}
                            setIsInitialSellerPOsData={setIsInitialSellerPOsData}
                        />
                    </div>
                } */}

                {isSearchVisible && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                        <Search
                            dataType={dataType}
                            setDataType={setDataType}
                            setSelectedDispatchSellerPOs={setSelectedDispatchSellerPOs}
                            setIsInitialSellerPOsData={setIsInitialSellerPOsData}
                        />
                        </Sidebar>
                    </div>
                }
            </div>
            <Dialog header="GRN And Quality Check" className='pi-punch-dialog grn-and-qc-dialog' visible={visibleGRN} style={{ width: '', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setVisibleGRN(false)}>
                <GRN selectedSellerPO={{ data: sellerPOIdData }} setVisibleGRN={() => setVisibleGRN(false)} isDisplayVisible={true} />
            </Dialog>
            <Dialog header="Create Dispatch Note" className='pi-punch-dialog create-dispatch-note-dialog' visible={isCreateDispatchNoteVisible} style={{ width: '95vw', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsCreateDispatchNoteVisible(false)}>
                <CreateDispatchNote
                    selectedDispatchSellerPOs={selectedDispatchSellerPOs}
                    selectedDispatchSellerPOItems={selectedDispatchSellerPOItems}
                    handleSubmitCreateDispatch={handleSubmitCreateDispatch}
                    logisticPartners={logisticPartners}
                    buyerCompanyBillAddrs={buyerCompanyBillAddrs}
                    buyerCompanyBranchShipAddrs={buyerCompanyBranchShipAddrs}
                    setBuyerCompanyBranchShipAddrs={setBuyerCompanyBranchShipAddrs}
                    selectedBuyerBillAddrId={selectedBuyerBillAddrId}
                    selectedBuyerShipAddrId={selectedBuyerShipAddrId}
                    setSelectedBuyerShipAddrId={setSelectedBuyerShipAddrId}
                    handleBillingAddress={handleBillingAddress}
                    handleShippingAddress={handleShippingAddress}
                    userId={userId}
                    isConfirmReplaceDialogVisible={isConfirmReplaceDialogVisible}
                    setIsConfirmReplaceDialogVisible={setIsConfirmReplaceDialogVisible}
                    setIsCreateInvoiceModalVisible={setIsCreateInvoiceModalVisible}
                    handleReplacementItemsAcceptClick={handleReplacementItemsAcceptClick}
                    handleReplacementItemsRejectClick={handleReplacementItemsRejectClick}
                    companySupplyTypes={companySupplyTypes}
                    HSNMasterData={HSNMasterData}
                    pmBranches={pmBranches}
                    handleOnClickRenameProducts={handleOnClickRenameProducts}
                />
            </Dialog>
            <Dialog header="Convert To Stock" className='pi-punch-dialog convert-to-stock-dialog' visible={isConvertToStockVisible} style={{ width: '', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsCovertToStockVisible(false)}>
                <ConvertToStock
                    selectedDispatchSellerPOs={selectedDispatchSellerPOs}
                    selectedDispatchSellerPOItems={selectedDispatchSellerPOItems}
                    setIsCovertToStockVisible={setIsCovertToStockVisible}
                    userId={userId}
                    handleSubmitConvertToStock={handleSubmitConvertToStock}
                />
            </Dialog>
            <Dialog header="Create Invoice" className='pi-punch-dialog' visible={isCreateInvoiceModalVisible} style={{ width: '80vw', minHeight: '45vh', backgroundColor: '#f8f8f8' }} onHide={() => setIsCreateInvoiceModalVisible(false)}>
                <CreateInvoice
                    newDispatchNote={newDispatchNote}
                    userId={userId}
                    handleSubmitCreateDispatchWithReplaceProducts={handleSubmitCreateDispatchWithReplaceProducts}
                />
            </Dialog>
            <Dialog header={`Schedule History for- ${materialStr}`} className="pi-punch-dialog" style={{ width: '50vw', minHeight: '20vh' }} visible={isScheduleHistoryVisible} onHide={() => { setIsScheduleHistoryVisible(false); setSelectedPOItemForViewSchedule(); setPOScheduleItems([]) }}>
                {
                    isScheduleLoading ?
                        (
                            <div className="flex flex-column justify-content-between align-items-center">
                                <Oval
                                    height={45}
                                    width={45}
                                    color="#00baac"
                                    visible={isScheduleLoading}
                                    ariaLabel='oval-loading'
                                    secondaryColor="#a4a7a6"
                                />
                            </div>
                        ) :
                        (
                            <div className="buyerpo-modal">
                                <div>
                                    <div className="custom-table-container">
                                        <table className="custom-product-table" style={{ width: "100%" }}>
                                            <thead>
                                                <tr className="">
                                                    <th className="" >SR</th>
                                                    <th className="" >Scheduled Date</th>
                                                    <th className="" >Scheduled Qty</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                                {
                                                    poScheduleItems?.map((eachPOScheduleItem, index) => {
                                                        return (
                                                            <tr className="">
                                                                <td className="">{index + 1}</td>
                                                                <td className="">{eachPOScheduleItem?.scheduledDate}</td>
                                                                <td className="">{eachPOScheduleItem?.scheduledQty}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )
                }
            </Dialog>
            <ConfirmDialog
                visible={isConfirmPreviewDialogVisible}
                onHide={() => {
                    setIsConfirmPreviewDialogVisible(false)
                    setPreviewBuyerInvoicesIds([])
                }}
                message={message}
                header="Active Preview Clash"
                icon="pi pi-exclamation-triangle"
                rejectLabel={""}
                acceptLabel={""}
                reject={() => {
                    setIsConfirmPreviewDialogVisible(false)
                    setPreviewBuyerInvoicesIds([])
                }}
                accept={() => {
                    setIsConfirmPreviewDialogVisible(false)
                    setPreviewBuyerInvoicesIds([])
                }}
                footer={footer}
            />
            <RenameBuyerInvoiceItems 
                visibleRenameBuyerInvoiceItems={visibleRenameBuyerInvoiceItems}
                setVisibleRenameBuyerInvoiceItems={setVisibleRenameBuyerInvoiceItems}
                buyerReqWiseDispatchNoteItems={buyerReqWiseDispatchNoteItems}
                buyerPOItemWiseDispatchNoteItems={buyerPOItemWiseDispatchNoteItems}
                newDispatchNote={newDispatchNote}
                itemsGroupedBy={newDispatchNote?.itemsGroupedBy}
                handleSubmit={handleSubmitCreateDispatchWithRenamedInvoiceItems}
                isLoading={isLoading}
            />
            <Loading visible={isLoading} />
        </div>
    )
}

export default Dispatch;